const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharelinkAmico(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-66",
    d: "M77.67,445.19c-95.18-54.95-95.18-144,0-199s249.49-54.95,344.66,0,95.18,144,0,199S172.84,500.14,77.67,445.19Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-66"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-66",
    cx: 395.42,
    cy: 406.4,
    rx: 70.72,
    ry: 40.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-66",
    d: "M172.75,341.73,20.08,429.82c-1.68,1-1.68,2.54,0,3.5l22.43,12.92a6.69,6.69,0,0,0,6.07,0l152.68-88.09c1.68-1,1.68-2.54,0-3.51l-22.43-12.91A6.72,6.72,0,0,0,172.75,341.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-66",
    d: "M238.75,421.06a10.51,10.51,0,0,1-5.19-1.31l-10.93-6.31-22.32,5.86a6.29,6.29,0,0,1-6.54-10l6.79-8.64-7.76-4.48a6.54,6.54,0,0,1,0-11.67l128.1-74a10.34,10.34,0,0,1,5.19-1.32,10.47,10.47,0,0,1,5.19,1.31l40.77,23.54a6.55,6.55,0,0,1,0,11.67L243.94,419.74A10.4,10.4,0,0,1,238.75,421.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-66",
    d: "M151.41,471.52a10.51,10.51,0,0,1-5.19-1.31l-40.76-23.53a6.54,6.54,0,0,1,0-11.67l45.9-26.5a11,11,0,0,1,10.39,0L202.5,432a6.54,6.54,0,0,1,0,11.67l-45.89,26.5A10.54,10.54,0,0,1,151.41,471.52Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.89 94.29 96 95.54 139.1 70.65 137 69.4 93.89 94.29",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137 69.4 96 93.07 96 49.16 137 25.5 137 69.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.07,17.41,92,46.87V102.4l51-29.46Zm-4,53.24L96,95.54V49.16l43.1-24.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.1 70.65 137 69.4 137 25.5 139.1 24.27 139.1 70.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.06 17.41 140.93 16.18 89.9 45.65 92.03 46.87 143.06 17.41",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.9 45.65 92.03 46.87 92.03 102.4 89.9 101.18 89.9 45.65",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "135.4 68.11 97.6 89.94 97.6 82.01 107.05 60.18 112.94 65.64 110.82 74.79 123.87 46.87 135.4 60.18 135.4 68.11",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58,47.41a6.21,6.21,0,0,0-2.8,4.85c0,1.78,1.26,2.5,2.8,1.61a6.19,6.19,0,0,0,2.8-4.84C115.38,47.25,114.12,46.52,112.58,47.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23.61 134.86 25.71 136.11 68.82 111.22 66.72 109.97 23.61 134.86",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.72 109.97 25.71 133.64 25.71 89.73 66.72 66.08 66.72 109.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.78,58l-51,29.46V143l51-29.47Zm-4,53.25L25.71,136.11V89.73L68.82,64.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.82 111.22 66.72 109.97 66.72 66.08 68.82 64.85 68.82 111.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.78 57.98 70.65 56.76 19.61 86.22 21.75 87.44 72.78 57.98",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.61 86.22 21.75 87.44 21.75 142.98 19.61 141.76 19.61 86.22",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "65.12 108.69 27.31 130.51 27.31 122.58 36.76 100.76 42.65 106.21 40.53 115.36 53.59 87.44 65.12 100.76 65.12 108.69",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3,88a6.17,6.17,0,0,0-2.8,4.84c0,1.78,1.25,2.51,2.8,1.62a6.2,6.2,0,0,0,2.79-4.85C45.09,87.82,43.84,87.1,42.3,88Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "482.67 231.58 480.67 232.76 412.99 193.69 414.98 192.5 482.67 231.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.98 192.5 480.67 230.42 480.67 79.08 414.98 41.17 414.98 192.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.23,195.85l75.2,43.42V76.91L409.23,33.5ZM413,40l67.68,39.08V232.76L413,193.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.99 193.69 414.98 192.5 414.98 41.17 412.99 40 412.99 193.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.67 177.77 480.67 180.1 412.99 141.02 414.98 139.84 480.67 177.77",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.67 125.08 480.67 127.42 412.99 88.34 414.98 87.15 480.67 125.08",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.23 33.5 411.25 32.34 486.45 75.75 484.43 76.91 409.23 33.5",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.45 75.75 484.43 76.91 484.43 239.27 486.45 238.11 486.45 75.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.73 62.36 449.7 61.2 449.7 214.89 451.73 213.73 451.73 62.36",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "445.95 59.04 449.7 61.2 449.7 214.89 445.95 212.71 445.95 59.04",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.23 86.17 409.23 90.5 484.43 133.92 484.43 129.59 409.23 86.17",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.23 138.85 409.23 143.18 484.43 186.59 484.43 182.26 409.23 138.85",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.7 109.54 451.73 108.37 480.67 125.08 480.67 127.42 449.7 109.54",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.7 162.2 451.73 161.03 480.67 177.74 480.67 180.08 449.7 162.2",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--icon--inject-66",
    d: "M213.35,73.79c1.58-2.42,3.48-3.75,5.18-3.88l8.59-29.74a4,4,0,0,1-1.37-1.38c-1.9-3.08-1.22-9,1.54-13.24s6.52-5.16,8.43-2.07,1.22,9-1.54,13.24c-1.57,2.42-3.48,3.75-5.18,3.88l-8.59,29.74a3.85,3.85,0,0,1,1.37,1.38,6.66,6.66,0,0,1,.84,2.19l19.07-12.77a16.67,16.67,0,0,1,2.59-8.07c2.75-4.23,6.53-5.16,8.44-2.07s1.21,9-1.54,13.24-6.53,5.16-8.43,2.07a6.89,6.89,0,0,1-.84-2.19L222.84,76.89A16.56,16.56,0,0,1,220.25,85c-2.75,4.23-6.53,5.16-8.43,2.07S210.6,78,213.35,73.79Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buttons--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.67,466.72l-40.76-23.53a6.08,6.08,0,0,1-2.74-4.75V432.9a6.06,6.06,0,0,1,2.74-4.74l45.9-26.5a6.08,6.08,0,0,1,5.48,0l40.76,23.53a6.08,6.08,0,0,1,2.74,4.75v5.54a6,6,0,0,1-2.74,4.74l-45.9,26.5A6.08,6.08,0,0,1,148.67,466.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.81,401.66l-45.9,26.5c-1.51.87-1.51,2.29,0,3.16l40.76,23.54a6.08,6.08,0,0,0,5.48,0l45.9-26.5c1.51-.88,1.51-2.29,0-3.17l-40.76-23.53A6.08,6.08,0,0,0,153.81,401.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.41,455.52v11.85a5.58,5.58,0,0,1-2.74-.65l-40.76-23.54a6,6,0,0,1-2.74-4.73V432.9a6.12,6.12,0,0,1,2.24-4.39c-1,.86-.82,2,.5,2.81l40.76,23.54A5.58,5.58,0,0,0,151.41,455.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57,430.16c.37-1.5,3-3,5.55-3.2l2.42-.2c1.34-.11,2.58-.83,2.77-1.6s-.74-1.31-2.08-1.2l-2.42.2a17.85,17.85,0,0,0-7.27,2.2c-2.09,1.21-3.45,2.7-3.82,4.2l-2.25,9.1c-.76,3.09,3,5.24,8.31,4.8l2.43-.2a17.71,17.71,0,0,0,7.27-2.21c2.09-1.21,3.44-2.7,3.81-4.19l1.07-4.3c.19-.78-.74-1.31-2.08-1.2s-2.58.82-2.77,1.6l-1.07,4.3c-.37,1.5-2.94,3-5.54,3.2l-2.42.2c-2.68.22-4.54-.86-4.16-2.4l2.25-9.1Zm17.67-4.2,2.25-9.1a3.26,3.26,0,0,0-1.86-3.73,11.35,11.35,0,0,0-6.45-1.07l-2.43.2a17.76,17.76,0,0,0-7.26,2.2c-2.09,1.21-3.45,2.7-3.82,4.2l-1,3.93c-.19.77.73,1.31,2.07,1.2s2.58-.83,2.78-1.6l1-3.93a3.69,3.69,0,0,1,1.91-2.1,8.76,8.76,0,0,1,3.63-1.1l2.43-.2a5.57,5.57,0,0,1,3.22.54,1.61,1.61,0,0,1,.93,1.86l-2.25,9.1c-.37,1.49-2.95,3-5.54,3.2-1.34.11-2.58.82-2.77,1.6s.73,1.31,2.07,1.2a17.86,17.86,0,0,0,7.27-2.21c2.09-1.21,3.45-2.7,3.82-4.19Zm0,0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.51,388v-5.54a6,6,0,0,1,2.74-4.74l128.1-74a6.08,6.08,0,0,1,5.48,0l40.76,23.53a6.08,6.08,0,0,1,2.74,4.75v5.54a6.06,6.06,0,0,1-2.74,4.74l-128.1,74a6.08,6.08,0,0,1-5.48,0l-40.76-23.54A6,6,0,0,1,192.51,388Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.33,332v5.54a6,6,0,0,1-2.74,4.74l-128.1,73.95a5.48,5.48,0,0,1-2.74.66V405.05a5.69,5.69,0,0,0,2.74-.66l128.1-73.95c1.32-.77,1.49-1.95.5-2.81A6.12,6.12,0,0,1,372.33,332Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,400.06l0,0,0,0-10.57,2.05V414h0a1.38,1.38,0,0,0,1.72,1.31l24.28-6.38V397.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.75,404.56a5.07,5.07,0,0,1-2.49-.59l-12.85-7.42L198.94,403l-.24,0a.9.9,0,0,1-.79-.51.85.85,0,0,1,.11-.93L208.66,388l-13.16-7.61a1.46,1.46,0,0,1-.89-1.15,1.49,1.49,0,0,1,.89-1.16l128.1-74a5.63,5.63,0,0,1,5,0l40.76,23.54a1.19,1.19,0,0,1,0,2.31l-128.1,74A5,5,0,0,1,238.75,404.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.09,304.07a4.7,4.7,0,0,1,2.25.52l40.76,23.53c.4.23.64.51.64.73s-.24.51-.64.73l-128.1,74a5,5,0,0,1-4.5,0l-12.67-7.32-.35-.2-.39.11-24.28,6.37-.11,0a.4.4,0,0,1-.35-.24.37.37,0,0,1,.05-.41l10.3-13.09.7-.89-1-.56L195.74,380c-.39-.23-.64-.51-.64-.73s.25-.5.64-.73l128.1-74a4.7,4.7,0,0,1,2.25-.52m0-1a5.58,5.58,0,0,0-2.74.66l-128.1,74c-1.51.87-1.51,2.29,0,3.16l12.68,7.32-10.3,13.08a1.38,1.38,0,0,0,1.07,2.24,1.56,1.56,0,0,0,.36-.05l24.28-6.37L236,404.39a6,6,0,0,0,5.48,0l128.1-74c1.51-.87,1.51-2.28,0-3.16l-40.76-23.53a5.58,5.58,0,0,0-2.74-.66Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,390a9.82,9.82,0,0,1-3.2.52,3.58,3.58,0,0,1-1.4-.37,3.14,3.14,0,0,1-1.23-1.22c-.28-.49-.24-.84.11-1.05a4.5,4.5,0,0,1,1-.26l1.16-.19a8.52,8.52,0,0,0,2.6-.83,2.35,2.35,0,0,0,1.14-1.17c.16-.42-.11-.84-.82-1.24a4.42,4.42,0,0,0-1.69-.58,7,7,0,0,0-1.77,0c-.58.06-1.36.17-2.36.34a23.46,23.46,0,0,1-5.88.32,11.73,11.73,0,0,1-4.77-1.6c-1.75-1-2.57-2.13-2.44-3.35s1.12-2.37,3-3.44a13.08,13.08,0,0,1,2.41-1,11.93,11.93,0,0,1,2.48-.57,2.6,2.6,0,0,1,1.55.29,4.27,4.27,0,0,1,1.27,1.12c.34.46.34.78,0,1a5.5,5.5,0,0,1-1.08.35,10,10,0,0,0-2.34.84c-.78.45-1.15.86-1.11,1.22a1.23,1.23,0,0,0,.7.91,4.35,4.35,0,0,0,2.22.63,19.84,19.84,0,0,0,3.05-.32l1.05-.17a20.74,20.74,0,0,1,5.43-.23,11.33,11.33,0,0,1,4.43,1.53,6,6,0,0,1,2.32,2.15,2.67,2.67,0,0,1,.11,2.53,6.14,6.14,0,0,1-2.69,2.53A15.77,15.77,0,0,1,236.35,390Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.75,383.19,226.51,371.5c-.62-.36-.37-.87.76-1.52l1-.58c1.14-.65,2-.8,2.64-.44l7.57,4.38a2.58,2.58,0,0,1,.14-1.73,3.4,3.4,0,0,1,1.53-1.53,6.18,6.18,0,0,1,3.5-.82,8.71,8.71,0,0,1,3.88,1.26l10.59,6.11c.62.36.37.87-.77,1.52l-1,.58c-1.13.65-2,.8-2.63.44l-9.6-5.55a3.53,3.53,0,0,0-1.39-.49,2.09,2.09,0,0,0-1.24.29,1,1,0,0,0-.5,1.37l10.15,5.86c.63.36.37.87-.76,1.52l-1,.58C248.26,383.4,247.38,383.55,246.75,383.19Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48,374.55a9.67,9.67,0,0,1-4.4-1.35q-5.47-3.15,1.38-7.07l-.47-.27a3.69,3.69,0,0,0-1.82-.56,3.49,3.49,0,0,0-1.81.52,4,4,0,0,0-1,.75,8,8,0,0,0-.66.91,1.06,1.06,0,0,1-.38.49,2.15,2.15,0,0,1-1.08.12,13.88,13.88,0,0,1-1.63-.23,4.26,4.26,0,0,1-1.15-.37.69.69,0,0,1-.26-.94,4,4,0,0,1,1.06-1.45,11,11,0,0,1,2-1.44,11.73,11.73,0,0,1,5.76-1.77,9.8,9.8,0,0,1,5.09,1.35l5.33,3.07c.9.52,1.6.9,2.12,1.14s1.1.51,1.74.79a4.44,4.44,0,0,1,.73.32c.31.18.15.54-.48,1.09a12.82,12.82,0,0,1-1.86,1.34,1.48,1.48,0,0,1-1,.18,11.29,11.29,0,0,1-1.53-.43,1.81,1.81,0,0,1,0,1.37,3.13,3.13,0,0,1-1.44,1.43A7.53,7.53,0,0,1,261.48,374.55Zm3-4.23a1,1,0,0,0-.07-.77l-3.43-2c-2,1.12-2.05,2.19-.32,3.19a3.84,3.84,0,0,0,1.68.53,2.64,2.64,0,0,0,1.54-.33A1.24,1.24,0,0,0,264.47,370.32Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.13,366.8l-9.33-5.39c-.86-.49-1.54-.86-2.05-1.1l-1.72-.77a5.63,5.63,0,0,1-.71-.31c-.31-.18-.15-.54.49-1.09a12.76,12.76,0,0,1,1.85-1.34,1.61,1.61,0,0,1,1.14-.18,7.11,7.11,0,0,1,1.2.33l.79.31a3.06,3.06,0,0,1-.67-1.49c0-.44.23-.82.79-1.15a2.72,2.72,0,0,1,1.68-.41,3.54,3.54,0,0,1,1.42.45,7.74,7.74,0,0,1,1.42,1.07c.52.47.67.76.45.89a5.15,5.15,0,0,1-.73.28,5.51,5.51,0,0,0-.87.37.87.87,0,0,0-.53.78,1.49,1.49,0,0,0,.5.93l9.21,5.32c.63.36.35.88-.82,1.56l-.82.47C276.65,367,275.76,367.16,275.13,366.8Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.77,360.24a16.86,16.86,0,0,1-7.41-2.42q-4.33-2.51-4.57-4.48c-.15-1.32.73-2.53,2.66-3.65a9.65,9.65,0,0,1,6.18-1.23,19.53,19.53,0,0,1,7.14,2.63,1.22,1.22,0,0,1,.44,1c.05.49,0,.8-.21.91l-5.56,3.21a6.27,6.27,0,0,0,2.8.84,4.53,4.53,0,0,0,2.29-.6,4,4,0,0,0,1-.78,5.89,5.89,0,0,0,.6-.84,1.69,1.69,0,0,1,.36-.5,2.29,2.29,0,0,1,1.08-.13,9.35,9.35,0,0,1,1.58.2,4.7,4.7,0,0,1,1.09.34.76.76,0,0,1,.33,1.11,4.65,4.65,0,0,1-1.17,1.47,9.2,9.2,0,0,1-1.65,1.22A12.27,12.27,0,0,1,284.77,360.24Zm-.83-7.37a14.36,14.36,0,0,0-3.32-1.52,2.71,2.71,0,0,0-2.06.17.78.78,0,0,0-.37,1.19,8.34,8.34,0,0,0,2.47,2.05Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85,351.49a2.51,2.51,0,0,1-1.15-.36l-18.43-10.65c-.63-.36-.37-.86.76-1.52l1.17-.67c1.13-.65,2-.8,2.63-.44L303.6,347l4.36-2.51a1.56,1.56,0,0,1,1-.19,3.93,3.93,0,0,1,1.32.53l.91.52a2.27,2.27,0,0,1,.9.76c.1.21,0,.41-.32.59L304,351.18A2.12,2.12,0,0,1,302.85,351.49Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.05,334.56l-1.76-1c-.62-.36-.28-.92,1-1.67s2.36-1,3-.64l1.75,1c.63.36.29.92-1,1.67S297.67,334.92,297.05,334.56Zm16.76,9.91-13.55-7.82c-.62-.36-.35-.88.82-1.55l.82-.48c1.17-.67,2.07-.83,2.69-.47L318.14,342c.62.36.35.88-.82,1.55l-.82.48C315.33,344.67,314.43,344.83,313.81,344.47Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.15,340.23l-9.33-5.39a28.85,28.85,0,0,0-3.1-1.62q-1-.42-1.23-.54c-.35-.2-.2-.59.45-1.16a12.2,12.2,0,0,1,1.89-1.37,1.51,1.51,0,0,1,1.05-.24,4.83,4.83,0,0,1,1.09.34l.93.39a2.7,2.7,0,0,1,0-1.86,3.38,3.38,0,0,1,1.58-1.64,6,6,0,0,1,3.48-.81,8.86,8.86,0,0,1,3.87,1.27l10.59,6.11c.62.36.37.87-.76,1.52l-1,.58c-1.13.65-2,.8-2.63.44l-9.6-5.55a3.78,3.78,0,0,0-1.36-.51,1.88,1.88,0,0,0-1.21.28,1.08,1.08,0,0,0-.53,1.38l10.15,5.86c.31.19.41.4.29.65a2.51,2.51,0,0,1-1,.86l-1,.59Q322.09,340.77,321.15,340.23Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.34,325.66c.31.18,0,.56-1.06,1.14l-1.63.95a3.18,3.18,0,0,1-.9.38,2.24,2.24,0,0,1-.8,0l-9.3-2.37-.33.19,6.32,3.65c.63.36.37.86-.76,1.52l-.93.54c-1.13.65-2,.8-2.64.44l-20.24-11.69c-.63-.36-.37-.87.76-1.52l.93-.54c1.14-.66,2-.8,2.64-.44l12.17,7,.14-.08L328.35,320c-.14-.22-.17-.38-.1-.49a2.35,2.35,0,0,1,.69-.49l1.52-.88q1.57-.92,2.07-.63a1.38,1.38,0,0,1,.41.48l3.48,5.18,10.16,2.25A2.94,2.94,0,0,1,347.34,325.66Z",
    style: {
      fill: "#FF7200"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.66,418.07l-42.1,3.29a1.73,1.73,0,0,0-1.57,1.7v2.78a2.75,2.75,0,0,0,1.42,2.28l26.76,13.16a1.06,1.06,0,0,0,1.62-.87l.55-4.3a1.54,1.54,0,0,1,1.76-1.34L224,436.66a3.19,3.19,0,0,0,2.6-1l1.95-2.26a4.92,4.92,0,0,0,1-2.77v-2.78a1.87,1.87,0,0,0-1.57-1.81l-6-.89,1.16-.65a2.79,2.79,0,0,0,1.15-2.23v-2.78A1.43,1.43,0,0,0,222.66,418.07Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.66,418.07l-42.1,3.29a1.73,1.73,0,0,0-1.57,1.7v2.78a2.75,2.75,0,0,0,1.42,2.28l26.76,13.16a1.06,1.06,0,0,0,1.62-.87l.55-4.3a1.54,1.54,0,0,1,1.76-1.34L224,436.66a3.19,3.19,0,0,0,2.6-1l1.95-2.26a4.92,4.92,0,0,0,1-2.77v-2.78a1.87,1.87,0,0,0-1.57-1.81l-6-.89,1.16-.65a2.79,2.79,0,0,0,1.15-2.23v-2.78A1.43,1.43,0,0,0,222.66,418.07Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.22,430.58v5.93a2.79,2.79,0,0,1-1.26.15l-12.86-1.89a1.59,1.59,0,0,0-.92.17v-6a1.53,1.53,0,0,1,.92-.14L224,430.72A2.77,2.77,0,0,0,225.22,430.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,435.47v5.94a1.24,1.24,0,0,1-.8-.13L180.4,428.12a2.76,2.76,0,0,1-1.41-2.28v-2.78a1.75,1.75,0,0,1,.95-1.53c-.19.16,0,.4.46.65l26.77,13.16A1.24,1.24,0,0,0,208,435.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.66,418.07l-42.1,3.29c-.87.07-.94.43-.15.82l26.76,13.16a1.06,1.06,0,0,0,1.62-.87l.55-4.3a1.54,1.54,0,0,1,1.76-1.34L224,430.72a3.19,3.19,0,0,0,2.6-1l1.95-2.26c.57-.66.34-1.3-.53-1.42l-12.86-1.9c-.87-.13-1-.58-.19-1l7.93-4.46C223.62,418.29,223.54,418,222.66,418.07Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.59,347.34V55.25c0-8-4-10.17-7.47-12.2s-9.31-3.25-14.3-.37L42.94,116.51c-5,2.88-9,9.9-9,15.66v292.1c0,5.76,3.62,9.16,7.14,11.19s9.64,4.26,14.63,1.38L183.55,363A17,17,0,0,0,192.59,347.34Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.59,347.34V55.25c0-8-4-10.17-7.47-12.2s-9.31-3.25-14.3-.37L42.94,116.51c-5,2.88-9,9.9-9,15.66v292.1c0,5.76,3.62,9.16,7.14,11.19s9.64,4.26,14.63,1.38L183.55,363A17,17,0,0,0,192.59,347.34Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.45,350.27,53,426.19l0-293.43-16.46-9.5a18.58,18.58,0,0,0-2.65,8.91v292.1c0,5.76,3.62,9.16,7.14,11.19s9.64,4.26,14.63,1.38L183.55,363a17.25,17.25,0,0,0,7.83-8.73l-.51-.3Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.45,350.27,53,426.19l0-293.43-16.46-9.5a18.58,18.58,0,0,0-2.65,8.91v292.1c0,5.76,3.62,9.16,7.14,11.19s9.64,4.26,14.63,1.38L183.55,363a17.25,17.25,0,0,0,7.83-8.73l-.51-.3Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,52.57,55.06,126.62a14,14,0,0,0-6.35,11V427.18c0,6.19,4.4,8.73,9.76,5.62l124.84-72.07a16,16,0,0,0,7.19-12.45V56.72C190.5,52.15,187.26,50.29,183.31,52.57Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,52.57,55.06,126.62a14,14,0,0,0-6.35,11V427.18c0,6.19,4.4,8.73,9.76,5.62l124.84-72.07a16,16,0,0,0,7.19-12.45V56.72C190.5,52.15,187.26,50.29,183.31,52.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.76,169.33a7.68,7.68,0,0,0-3.34-6.05,2.26,2.26,0,0,0-2.3-.19c-.42.26-2.06,1.18-2.5,1.44a2.6,2.6,0,0,0-1,2.37v25.24a7.63,7.63,0,0,0,3.34,6,2.26,2.26,0,0,0,2.21.23c.46-.24,2.15-1.21,2.58-1.47a2.62,2.62,0,0,0,1-2.38Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.76,169.33a7.68,7.68,0,0,0-3.34-6.05,2.26,2.26,0,0,0-2.3-.19c-.42.26-2.06,1.18-2.5,1.44a2.6,2.6,0,0,0-1,2.37v25.24a7.63,7.63,0,0,0,3.34,6,2.26,2.26,0,0,0,2.21.23c.46-.24,2.15-1.21,2.58-1.47a2.62,2.62,0,0,0,1-2.38Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.27,170.76V196c0,2.27-1.49,3.25-3.34,2.18a7.63,7.63,0,0,1-3.34-6V166.9c0-2.27,1.49-3.25,3.34-2.18A7.61,7.61,0,0,1,43.27,170.76Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.27,170.76V196c0,2.27-1.49,3.25-3.34,2.18a7.63,7.63,0,0,1-3.34-6V166.9c0-2.27,1.49-3.25,3.34-2.18A7.61,7.61,0,0,1,43.27,170.76Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.76,213.49a7.64,7.64,0,0,0-3.34-6,2.22,2.22,0,0,0-2.3-.19l-2.5,1.43a2.62,2.62,0,0,0-1,2.38V236.3a7.61,7.61,0,0,0,3.34,6,2.24,2.24,0,0,0,2.21.24c.46-.24,2.15-1.22,2.58-1.48a2.6,2.6,0,0,0,1-2.37Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.76,213.49a7.64,7.64,0,0,0-3.34-6,2.22,2.22,0,0,0-2.3-.19l-2.5,1.43a2.62,2.62,0,0,0-1,2.38V236.3a7.61,7.61,0,0,0,3.34,6,2.24,2.24,0,0,0,2.21.24c.46-.24,2.15-1.22,2.58-1.48a2.6,2.6,0,0,0,1-2.37Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.27,214.93v25.23c0,2.27-1.49,3.25-3.34,2.18a7.61,7.61,0,0,1-3.34-6V211.07c0-2.28,1.49-3.25,3.34-2.19A7.63,7.63,0,0,1,43.27,214.93Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.27,214.93v25.23c0,2.27-1.49,3.25-3.34,2.18a7.61,7.61,0,0,1-3.34-6V211.07c0-2.28,1.49-3.25,3.34-2.19A7.63,7.63,0,0,1,43.27,214.93Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.24,71.4V341a15.13,15.13,0,0,1-6.83,11.84L61.8,419.54C58,421.73,55,420,55,415.6V144a15.24,15.24,0,0,1,4.79-10.29l.65-.59a12.23,12.23,0,0,1,1.39-.95l32.52-18.78,2.12-1.22c1.17-.68,2.12-.13,2.12,1.22s1,1.87,2.26,1.14l37.9-21.88A4.88,4.88,0,0,0,141,88.86a4.81,4.81,0,0,1,1.9-3.56l.22-.13,31.81-18.36.68-.4C180.36,63.67,184.24,65.91,184.24,71.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.24,83.4v-13c0-5.49-3.88-7.74-8.64-5l-.68.4L143.11,84.2l-.22.13a4.79,4.79,0,0,0-1.9,3.55,4.88,4.88,0,0,1-2.27,3.75l-37.9,21.88c-1.25.73-2.26.21-2.26-1.14s-1-1.9-2.12-1.22l-2.12,1.22L61.8,131.15a11.05,11.05,0,0,0-1.39.95l-.65.58A15.26,15.26,0,0,0,55,143V158Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,140.43a.32.32,0,0,1,0-.17v-.8l-1.26.73c-.07,0-.1,0-.1-.12v-.28a.71.71,0,0,1,0-.16s0-.1,0-.16L74,135.81l.07-.14a.15.15,0,0,1,.08-.08l.18-.1c.05,0,.09,0,.11,0a.26.26,0,0,1,0,.18v2.82l.28-.16s.09,0,.11,0a.36.36,0,0,1,0,.18v.19a.53.53,0,0,1,0,.2.25.25,0,0,1-.11.12l-.28.16V140a.53.53,0,0,1,0,.2.37.37,0,0,1-.12.13l-.21.12C74.05,140.45,74,140.45,74,140.43Zm.05-1.71v-2l-.91,2.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.49,139.08a2.74,2.74,0,0,1-.37-1.65,5.39,5.39,0,0,1,.37-2.07,2.56,2.56,0,0,1,1.05-1.26,1.3,1.3,0,0,1,.5-.19.55.55,0,0,1,.39.05.08.08,0,0,1,0,.08.18.18,0,0,1,0,.09l-.11.42s0,.08,0,.09,0,0-.05,0a.7.7,0,0,0-.64.1,1.67,1.67,0,0,0-.72.87,3.93,3.93,0,0,0-.26,1.53,2.16,2.16,0,0,0,.25,1.24c.17.21.4.22.69.06a2.26,2.26,0,0,0,.31-.23,1.54,1.54,0,0,0,.25-.27v-1.31l-.52.3c-.06,0-.1,0-.12,0a.36.36,0,0,1,0-.18v-.18a.58.58,0,0,1,0-.21.23.23,0,0,1,.12-.12l.83-.48c.06,0,.1,0,.13,0s0,.1,0,.21v1.87c0,.07,0,.12,0,.16a.49.49,0,0,1-.06.13,2.66,2.66,0,0,1-1,1C76.09,139.38,75.74,139.37,75.49,139.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.12,132.64a1.94,1.94,0,0,1-.73,1.55c-.4.23-.73-.08-.73-.7a1.93,1.93,0,0,1,.73-1.55C85.79,131.7,86.12,132,86.12,132.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.39,130.09a4.41,4.41,0,0,0-1.7,2.56c-.07.23,0,.44.07.51h0c.13.09.34-.09.42-.38a3.12,3.12,0,0,1,1.2-1.8.78.78,0,0,1,1.2.42c.08.19.29.14.43-.11h0a.73.73,0,0,0,.07-.6A1.1,1.1,0,0,0,85.39,130.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.39,128.29A6.79,6.79,0,0,0,82.78,132c-.09.24-.06.48.06.56h0c.13.09.33-.08.42-.36a5.59,5.59,0,0,1,2.13-3,1.41,1.41,0,0,1,2.13.58c.1.17.29.12.42-.13h0A.69.69,0,0,0,88,129,1.73,1.73,0,0,0,85.39,128.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.46,114.26a.14.14,0,0,1,0-.13.34.34,0,0,1,0-.17l1-1.88.08-.13s.06-.08.09-.09l.38-.22a.07.07,0,0,1,.09,0,.16.16,0,0,1,0,.12v4.82a.32.32,0,0,1,0,.16.31.31,0,0,1-.09.12l-.39.22a.09.09,0,0,1-.1,0,.21.21,0,0,1,0-.12v-3.69l-.68,1.23a.17.17,0,0,1-.1.09s-.06,0-.09,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,112.84a.14.14,0,0,1,0-.13.3.3,0,0,1,.05-.16l1-1.88.08-.14a.38.38,0,0,1,.09-.09l.38-.22a.06.06,0,0,1,.09,0s0,.06,0,.12v4.81a.35.35,0,0,1-.13.28l-.39.23a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.12v-3.68l-.68,1.22s-.06.09-.1.1a.09.09,0,0,1-.09,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.12,110.78s.07,0,.09,0a.12.12,0,0,1,0,.11v.74a.32.32,0,0,1,0,.16.17.17,0,0,1-.09.11l-.45.26a.07.07,0,0,1-.09,0,.16.16,0,0,1,0-.12v-.73a.35.35,0,0,1,0-.17.25.25,0,0,1,.09-.11Zm0,2.61s.07,0,.09,0a.16.16,0,0,1,0,.12v.74a.32.32,0,0,1,0,.16.2.2,0,0,1-.09.11l-.45.26a.07.07,0,0,1-.09,0,.16.16,0,0,1,0-.12v-.73a.35.35,0,0,1,0-.17.25.25,0,0,1,.09-.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,113a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.12V112l-1.51.87a.06.06,0,0,1-.09,0,.17.17,0,0,1,0-.12v-.53a.48.48,0,0,1,0-.2c0-.06,0-.13.07-.21l1.48-3.7c.07-.16.13-.27.2-.3l.37-.22a.07.07,0,0,1,.09,0s0,.06,0,.12v3l.42-.24a.06.06,0,0,1,.09,0,.17.17,0,0,1,0,.12v.53a.47.47,0,0,1,0,.16.35.35,0,0,1-.09.11l-.42.24v.91a.32.32,0,0,1,0,.16.25.25,0,0,1-.09.11Zm-.13-2v-1.6l-.83,2.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65,106.89a.53.53,0,0,1,0-.17.35.35,0,0,1,.09-.11l1.82-1a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.12v.53a.53.53,0,0,1,0,.16.27.27,0,0,1-.1.11l-1.36.79,0,1a1.14,1.14,0,0,1,.26-.24l.21-.14a1.45,1.45,0,0,1,.5-.18.63.63,0,0,1,.41.1.77.77,0,0,1,.26.39,1.84,1.84,0,0,1,.1.68,3.37,3.37,0,0,1-.37,1.59,2.32,2.32,0,0,1-.41.55,2.21,2.21,0,0,1-.49.39,1.34,1.34,0,0,1-.57.21.63.63,0,0,1-.4-.09.66.66,0,0,1-.24-.34,1.79,1.79,0,0,1-.09-.5.35.35,0,0,1,.13-.28l.4-.22a.08.08,0,0,1,.08,0,.14.14,0,0,1,.06.1.41.41,0,0,0,.09.23.24.24,0,0,0,.14.09.43.43,0,0,0,.19,0l.21-.1a1.17,1.17,0,0,0,.44-.49,1.48,1.48,0,0,0,.17-.73.51.51,0,0,0-.17-.46.38.38,0,0,0-.44,0,1.14,1.14,0,0,0-.23.17,1,1,0,0,0-.14.16,1.47,1.47,0,0,1-.1.13.27.27,0,0,1-.11.1l-.44.25s-.07,0-.09,0a.16.16,0,0,1,0-.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.06 149.07 60.06 147.52 61.41 146.74 61.41 148.29 60.06 149.07",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.08 147.91 62.08 144.8 63.43 144.02 63.43 147.13 62.08 147.91",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.1 146.74 64.1 142.08 65.45 141.3 65.45 145.96 64.1 146.74",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.12 145.57 66.12 139.36 67.47 138.58 67.47 144.8 66.12 145.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.49,75.68c-.14-.21-.32-.27-.5-.16l-5,2.89a1.94,1.94,0,0,0-.58,1.52v2.83a1.66,1.66,0,0,0,.22.9.59.59,0,0,0,.2.19.32.32,0,0,0,.3,0l5-2.89a2,2,0,0,0,.58-1.53V76.58A1.66,1.66,0,0,0,178.49,75.68Zm-5.75,7.62a.86.86,0,0,1-.08-.42V80.06a1.49,1.49,0,0,1,.44-1.16l5-2.89a.16.16,0,0,1,.16,0,.34.34,0,0,1,.06.06.84.84,0,0,1,.08.41v2.83a1.49,1.49,0,0,1-.44,1.16l-5,2.89A.15.15,0,0,1,172.74,83.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.06,78.84v3.34l-.79.45a.11.11,0,0,1-.16-.09V80.06a1.19,1.19,0,0,1,.33-.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.42 78.63 175.37 78.08 175.37 81.43 174.42 81.97 174.42 78.63",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.73 77.88 176.68 77.33 176.68 80.69 175.73 81.22 175.73 77.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,76.8v2.41a1.27,1.27,0,0,1-.63,1.08l-.32.18V77.13l.75-.43A.13.13,0,0,1,178,76.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9,76.49c.14-.08.25.32.25.9v.53a2.09,2.09,0,0,1-.26,1.22l-.25.17V76.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.75 85.03 169.64 80.69 168.13 87.05 167.42 84.41 164.75 85.03",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,91.92l-17.37,10a4,4,0,0,0-1.88,3.12c0,1.12.84,1.55,1.88,1L124,96a4,4,0,0,0,1.88-3.12C125.83,91.75,125,91.32,124,91.92Zm8.91-6a4.71,4.71,0,0,0-2.11,3.66c0,1.35.95,1.9,2.11,1.22A4.66,4.66,0,0,0,135,87.17C135,85.82,134,85.28,132.86,86Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,91.92l-17.37,10a4,4,0,0,0-1.88,3.12c0,1.12.84,1.55,1.88,1L124,96a4,4,0,0,0,1.88-3.12C125.83,91.75,125,91.32,124,91.92Zm8.91-6a4.71,4.71,0,0,0-2.11,3.66c0,1.35.95,1.9,2.11,1.22A4.66,4.66,0,0,0,135,87.17C135,85.82,134,85.28,132.86,86Z",
    style: {
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Video--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.31,164.59l102.27-59c2.33-1.35,4.21-.26,4.21,2.43v86a9.29,9.29,0,0,1-4.21,7.29L68.31,260.36c-2.33,1.34-4.21.25-4.21-2.43v-86A9.31,9.31,0,0,1,68.31,164.59Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.31,164.59l102.27-59c2.33-1.35,4.21-.26,4.21,2.43v86a9.29,9.29,0,0,1-4.21,7.29L68.31,260.36c-2.33,1.34-4.21.25-4.21-2.43v-86A9.31,9.31,0,0,1,68.31,164.59Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.32,216.6a13.27,13.27,0,0,1-6.75-1.77c-5.64-3.26-8.88-10.65-8.88-20.27a55.94,55.94,0,0,1,7.56-27.06,48.67,48.67,0,0,1,5.37-7.59h0a35.47,35.47,0,0,1,9-7.64c6-3.5,12-3.92,16.71-1.2,5.64,3.26,8.87,10.65,8.87,20.28a55.92,55.92,0,0,1-7.55,27.05c-3.88,6.71-9,12.12-14.38,15.24A20.1,20.1,0,0,1,111.32,216.6Zm-.22-54.55a45.37,45.37,0,0,0-5,7.08A52.54,52.54,0,0,0,99,194.56c0,8.42,2.64,14.78,7.24,17.43,3.66,2.11,8.43,1.69,13.42-1.19s9.59-7.82,13.18-14a52.63,52.63,0,0,0,7.11-25.42c0-8.43-2.63-14.78-7.23-17.44-3.66-2.11-8.43-1.69-13.43,1.19a32.44,32.44,0,0,0-8.16,7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,177.87,113.58,200.8c-1.67,2.07-3,1.74-3-.74V176.43c0-2.49,1.35-4.38,3-4.23L132,173.85C133.68,174,133.68,175.8,132,177.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--video--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.58,302.4,68.31,361.45a9.28,9.28,0,0,0-4.21,7.29v40l31.61-18.24,3.36-1.94h0l11.49-6.63,19.66-11.34h0l9.56-5.54,3.1-1.79,31.9-18.41v-40C174.79,302.15,172.91,301.06,170.58,302.4Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.58,302.4,68.31,361.45a9.28,9.28,0,0,0-4.21,7.29v40l31.61-18.24,3.36-1.94h0l11.49-6.63,19.66-11.34h0l9.56-5.54,3.1-1.79,31.9-18.41v-40C174.79,302.15,172.91,301.06,170.58,302.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.33,347.92c-4.73-2.72-10.66-2.29-16.71,1.2a35.5,35.5,0,0,0-9,7.64,48.67,48.67,0,0,0-5.37,7.59,56.13,56.13,0,0,0-7.54,26.12l3.36-1.94h0a53.57,53.57,0,0,1,7-22.53,46.2,46.2,0,0,1,5-7.08,32.44,32.44,0,0,1,8.17-7c5-2.89,9.77-3.31,13.43-1.2,4,2.3,6.52,7.42,7.1,14.25l3.1-1.79C142,356,139,350.6,134.33,347.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.22,370.55l-19.66,11.34v-8.61c0-2.48,1.35-4.38,3-4.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.32,268.31,149,220.58c1.16-.67,2.1-.19,2.1,1.06a4.5,4.5,0,0,1-2.11,3.5L66.2,272.94c-1.16.67-2.07.18-2-1.1A4.69,4.69,0,0,1,66.32,268.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32,277.43l40.36-23.32c1.17-.67,2.11-.19,2.11,1.07a4.51,4.51,0,0,1-2.11,3.49L66.2,282.06c-1.16.67-2.07.18-2-1.1A4.69,4.69,0,0,1,66.32,277.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.14,216.09a1.21,1.21,0,0,1-.75-.25L166,213.26a1.24,1.24,0,1,1,1.5-2l2.24,1.69,2.73-5.22a1.24,1.24,0,0,1,2.2,1.16l-3.41,6.51a1.23,1.23,0,0,1-.83.64A1.24,1.24,0,0,1,170.14,216.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.26,304.27a.41.41,0,0,1-.18,0,.38.38,0,0,1-.18-.32v-7.18a.38.38,0,0,1,.18-.32l1.82-1a.36.36,0,0,1,.54.31v7.18a.36.36,0,0,1-.18.32l-1.82,1.05A.37.37,0,0,1,64.26,304.27Zm.37-7.34v6.34l1.09-.63V296.3Zm1.45,5.92h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.66,302.34a.31.31,0,0,1-.18,0,.35.35,0,0,1-.18-.31V294.8a.38.38,0,0,1,.18-.32c.66-.38,1.67-3,2-4.45.25-1.27.86-1.35,1-1.33s.61.24.66.82a20.27,20.27,0,0,1-.18,3l1.19-.69h0a.77.77,0,0,1,.85,0,1.34,1.34,0,0,1,.41,1.35l-.75,5.35a2.22,2.22,0,0,1-.89,1.55l-3.89,2.24A.32.32,0,0,1,67.66,302.34ZM68,295v6.37l3.34-1.93a1.54,1.54,0,0,0,.54-1l.75-5.36c.06-.42-.06-.62-.1-.64l-.25-.28.18.31-1.66,1a.44.44,0,0,1-.47,0,.52.52,0,0,1-.21-.53,25.46,25.46,0,0,0,.24-3.26s0,0,0-.07a1.79,1.79,0,0,0-.23.65C69.93,291.27,69,294.14,68,295Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.07,281.23a.37.37,0,0,1-.18-.05.36.36,0,0,1-.18-.32v-7.18a.36.36,0,0,1,.18-.32l1.81-1.05a.4.4,0,0,1,.37,0,.38.38,0,0,1,.18.32v7.18a.38.38,0,0,1-.18.32l-1.82,1.05A.37.37,0,0,1,97.07,281.23Zm.36-7.34v6.34l1.09-.63v-6.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.72,287.83h0c-.27,0-.61-.24-.66-.82a19.74,19.74,0,0,1,.18-3l-1.19.69h0a.77.77,0,0,1-.85,0,1.31,1.31,0,0,1-.41-1.34l.75-5.36a2.18,2.18,0,0,1,.89-1.55l3.89-2.24a.37.37,0,0,1,.55.31v7.19a.35.35,0,0,1-.18.31c-.66.38-1.67,3-2,4.45C93.48,287.72,92.93,287.83,92.72,287.83Zm-.17-4.74a.45.45,0,0,1,.24.06.54.54,0,0,1,.21.53,24.55,24.55,0,0,0-.24,3.26s0,.05,0,.08a2,2,0,0,0,.23-.66c.22-1.09,1.14-4,2.12-4.81v-6.36l-3.34,1.93a1.51,1.51,0,0,0-.54,1l-.75,5.36c-.06.42.06.62.1.64l.25.29-.18-.32,1.66-1A.49.49,0,0,1,92.55,283.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.26,245.3l-.09,0a.35.35,0,0,1-.27-.4c.95-6.78,4.49-10,5.27-10.63v-3.09a.37.37,0,0,1,.23-.33.35.35,0,0,1,.39.07l3.35,3.22a.37.37,0,0,1,.07.42l-3.34,7.08a.37.37,0,0,1-.7-.16v-2.79c-2,1.15-3.64,4-4.57,6.39A.37.37,0,0,1,165.26,245.3ZM170.9,232v2.41a.35.35,0,0,1-.15.29,14.59,14.59,0,0,0-4.48,7.25,9.76,9.76,0,0,1,4.13-4.23.41.41,0,0,1,.34,0,.38.38,0,0,1,.16.31v1.76l2.54-5.38Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.78,260.19a.41.41,0,0,1-.18-.05.38.38,0,0,1-.18-.32v-2.63a.37.37,0,0,1,.36-.37.38.38,0,0,1,.37.37v2l7.06-4.08v-2.42a.38.38,0,0,1,.37-.37.37.37,0,0,1,.36.37v2.63a.38.38,0,0,1-.18.32l-7.8,4.5A.37.37,0,0,1,139.78,260.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.68,254.58a.38.38,0,0,1-.37-.37v-7a.38.38,0,0,1,.37-.37.37.37,0,0,1,.36.37v7A.37.37,0,0,1,143.68,254.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.68,255.36a.36.36,0,0,1-.25-.11l-2-1.95a.36.36,0,1,1,.51-.52l1.66,1.6,1.8-3.83a.37.37,0,0,1,.49-.17.35.35,0,0,1,.17.48l-2,4.29a.37.37,0,0,1-.27.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.4,276.41h-.08a.35.35,0,0,1-.28-.35V263.27a.35.35,0,0,1,.18-.31l6.06-3.51a.4.4,0,0,1,.37,0,.38.38,0,0,1,.18.32v12.78a.36.36,0,0,1-.22.33.37.37,0,0,1-.4-.07l-2.66-2.54-2.82,5.93A.36.36,0,0,1,115.4,276.41Zm.37-12.93v10.95l2.33-4.93a.39.39,0,0,1,.27-.21.36.36,0,0,1,.31.1l2.42,2.31V260.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.89,308.65l-8.48,4.9c-.54.31-1,0-1-.74v-.2a2.34,2.34,0,0,1,1-1.87l8.48-4.9c.55-.32,1,0,1,.74v.2A2.33,2.33,0,0,1,72.89,308.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74,293.73l-8.48,4.9c-.55.31-1,0-1-.74v-.2a2.36,2.36,0,0,1,1-1.88l8.48-4.89c.54-.32,1,0,1,.74v.19A2.35,2.35,0,0,1,98.74,293.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67,279.91l-8.48,4.9c-.54.31-1,0-1-.74v-.2a2.34,2.34,0,0,1,1-1.87l8.48-4.9c.55-.32,1,0,1,.74V278A2.33,2.33,0,0,1,122.67,279.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.92,265.34l-8.48,4.89c-.55.32-1,0-1-.74v-.19a2.33,2.33,0,0,1,1-1.88l8.48-4.9c.54-.31,1,0,1,.74v.2A2.38,2.38,0,0,1,147.92,265.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,250.39l-8.48,4.9c-.54.31-1,0-1-.75v-.19a2.35,2.35,0,0,1,1-1.88l8.48-4.9c.55-.31,1,0,1,.74v.2A2.36,2.36,0,0,1,173.81,250.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,327.38a4,4,0,0,0-4,.31c-3.28,1.9-6,7-6,11.38,0,2.15.66,3.82,1.81,4.68,0,0,0,0,0,0l.15.1.13.09.09,0,.15.07.27.12.18.06.24.06.22,0,.21,0,.24,0a5,5,0,0,0,2.43-.73l.6-.39.1-.08.49-.38s0,0,.05-.05A13.1,13.1,0,0,0,70.34,339v0a14.72,14.72,0,0,0,1.78-6.67C72.12,330,71.35,328.16,70,327.38Zm-3,2.34a1.08,1.08,0,0,1,.54.13,2,2,0,0,1,.74,1.8A5.58,5.58,0,0,1,66,336.11a1.39,1.39,0,0,1-1.4.13,2,2,0,0,1-.74-1.8A5.58,5.58,0,0,1,66.16,330,1.77,1.77,0,0,1,67,329.72Zm2.87,9.34-.29.49-.17.28-.27.41-.22.32-.25.33-.27.33-.23.28c-.1.11-.2.22-.31.32a2.39,2.39,0,0,1-.22.23c-.1.11-.22.21-.33.31l-.21.19-.37.29-.2.15a5.15,5.15,0,0,1-.58.37l-.51.27c-.1.05-.21.08-.31.12l-.19.07-.35.11a.58.58,0,0,0-.14,0l-.34.05L64,344h-.47l-.25,0-.21,0-.21-.06-.23-.08-.16-.08a1.71,1.71,0,0,1-.23-.13l-.08-.06v-.13A7.37,7.37,0,0,1,65.2,338l1.91-1.1a1.89,1.89,0,0,1,1.84-.19,2.36,2.36,0,0,1,1,2v.17A1.28,1.28,0,0,0,69.89,339.06Zm-2.16-9.51a1.71,1.71,0,0,0-1.76.12,6,6,0,0,0-2.49,4.77,2.29,2.29,0,0,0,.92,2.1,1.32,1.32,0,0,0,.7.19,2.27,2.27,0,0,0,1.06-.31,6,6,0,0,0,2.49-4.77A2.29,2.29,0,0,0,67.73,329.55ZM66,336.11a1.39,1.39,0,0,1-1.4.13,2,2,0,0,1-.74-1.8A5.58,5.58,0,0,1,66.16,330a1.77,1.77,0,0,1,.86-.26,1.08,1.08,0,0,1,.54.13,2,2,0,0,1,.74,1.8A5.58,5.58,0,0,1,66,336.11Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.23,324.36,118.59,301c1.16-.67,2.11-.19,2.11,1.06a4.56,4.56,0,0,1-2.11,3.5L78.11,329c-1.16.67-2.08.18-2-1.1A4.69,4.69,0,0,1,78.23,324.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.06,334.63a.49.49,0,0,1-.42-.24.47.47,0,0,1,.18-.66l34.55-20a.47.47,0,0,1,.66.18.49.49,0,0,1-.18.66L77.3,334.57A.5.5,0,0,1,77.06,334.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.12,280.86h0a2.12,2.12,0,0,1-1.06-2.09v-2c0-2.28-1.39-3.33-3.1-2.34h0a7.4,7.4,0,0,0-3.1,5.92v1.79a7.13,7.13,0,0,1-1,3.5h0a1.9,1.9,0,0,0-.26.91h0c0,.58.35.84.78.59l7.25-4.18a1.88,1.88,0,0,0,.78-1.5A.74.74,0,0,0,167.12,280.86ZM163,287.65a3.57,3.57,0,0,0,1.49-2.84l-3,1.72C161.46,287.62,162.12,288.13,163,287.65Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.12,280.86h0a2.12,2.12,0,0,1-1.06-2.09v-2c0-2.28-1.39-3.33-3.1-2.34h0a7.4,7.4,0,0,0-3.1,5.92v1.79a7.13,7.13,0,0,1-1,3.5h0a1.9,1.9,0,0,0-.26.91h0c0,.58.35.84.78.59l7.25-4.18a1.88,1.88,0,0,0,.78-1.5A.74.74,0,0,0,167.12,280.86ZM163,287.65a3.57,3.57,0,0,0,1.49-2.84l-3,1.72C161.46,287.62,162.12,288.13,163,287.65Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.27,324.77a.48.48,0,0,1-.42-.25.47.47,0,0,1,.18-.66l118.47-68.4a.47.47,0,0,1,.66.18.48.48,0,0,1-.17.66L60.51,324.7A.42.42,0,0,1,60.27,324.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.27,354.08a.48.48,0,0,1-.24-.9L178.5,284.77a.49.49,0,0,1,.66.18.48.48,0,0,1-.17.66L60.51,354A.5.5,0,0,1,60.27,354.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.56,336.72a5.45,5.45,0,0,0,2.35,4.24l1.92,1.15a5.11,5.11,0,0,0,4.31.2c-1.11.44-1.95-.22-1.95-1.61V116.47a5.07,5.07,0,0,1,.69-2.41l-6.63-4a5.11,5.11,0,0,0-.69,2.41Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,336.72a5.45,5.45,0,0,0,2.35,4.24l1.92,1.15a5.11,5.11,0,0,0,4.31.2c-1.11.44-1.95-.22-1.95-1.61V116.47a5.07,5.07,0,0,1,.69-2.41l-6.63-4a5.11,5.11,0,0,0-.69,2.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.22,341.51a2.2,2.2,0,0,1-.31.15h0l-.09,0a1.17,1.17,0,0,1-.35.06c-.55,0-.63-.66-.63-1.06V116.47a4.5,4.5,0,0,1,.6-2.07,4.21,4.21,0,0,1,1.41-1.58L342.59,36.9a1.51,1.51,0,0,1,.73-.25c.11,0,.43,0,.56.54a2.31,2.31,0,0,1,.06.52V261.94c0,1.5,0,2.41-1.79,3.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.24,37.36a2.16,2.16,0,0,1,0,.35V261.94c0,1.42,0,2-1.46,2.87L214.86,340.92a.61.61,0,0,1-.18.09h-.05l-.07,0a1.36,1.36,0,0,1,0-.36V116.47a3.88,3.88,0,0,1,.53-1.74,3.44,3.44,0,0,1,1.15-1.3L342.92,37.5a1.21,1.21,0,0,1,.32-.14m.08-1.4a2.08,2.08,0,0,0-1.06.34L215.54,112.23a4.79,4.79,0,0,0-1.66,1.83,5.19,5.19,0,0,0-.69,2.41V340.69c0,1.12.53,1.76,1.3,1.76a1.74,1.74,0,0,0,.57-.11l.08,0a3.17,3.17,0,0,0,.41-.21L342.47,266c2.13-1.25,2.14-2.51,2.14-4.07V37.71a3.32,3.32,0,0,0-.08-.69A1.25,1.25,0,0,0,343.32,36Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54,37c-.28-1-1.19-1.37-2.28-.72L215.54,112.23a4.86,4.86,0,0,0-1.66,1.83l-6.62-4a4.84,4.84,0,0,1,1.65-1.83L335.62,32.32a5.11,5.11,0,0,1,4.72,0l1.92,1.16A5.43,5.43,0,0,1,344.54,37Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54,37c-.28-1-1.19-1.37-2.28-.72L215.54,112.23a4.86,4.86,0,0,0-1.66,1.83l-6.62-4a4.84,4.84,0,0,1,1.65-1.83L335.62,32.32a5.11,5.11,0,0,1,4.72,0l1.92,1.16A5.43,5.43,0,0,1,344.54,37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,218.45l-9.41,10.11a1.6,1.6,0,0,0,.32,2.43h0l6.62,4h0a1.39,1.39,0,0,0,.95.21l9.48-1.17-1.33-11.57Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,218.45l-9.41,10.11a1.6,1.6,0,0,0,.32,2.43h0l6.62,4h0a1.39,1.39,0,0,0,.95.21l9.48-1.17-1.33-11.57Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.52,221l-10.73,11.55a1.55,1.55,0,0,0,1.25,2.62l9.48-1.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.55,233.31a.46.46,0,0,0-.09.48.45.45,0,0,0,.39.28l9.67-1.17V234L205,235.16a1.56,1.56,0,0,1-1.25-2.62l9.41-10.11v-2.9h1.33v3Z",
    style: {
      fill: "#FF7200"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Content--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.22,114.14a3.56,3.56,0,0,1,1.68-.57,2,2,0,0,1,1.2.28,1.94,1.94,0,0,1,.74.88,3.27,3.27,0,0,1,.27,1.19.94.94,0,0,1-.1.49.82.82,0,0,1-.28.32l-1,.58q-.24.14-.36.06a.62.62,0,0,1-.22-.25,1.09,1.09,0,0,0-.65-.58,1.7,1.7,0,0,0-1.28.34,3.79,3.79,0,0,0-.71.52,4.24,4.24,0,0,0-.58.69,3.16,3.16,0,0,0-.39.78,2.41,2.41,0,0,0-.14.83,1.55,1.55,0,0,0,.13.74.58.58,0,0,0,.46.29,2.61,2.61,0,0,0,.84-.06c.35-.07.79-.17,1.31-.3a5.23,5.23,0,0,1,1.47-.18,1.67,1.67,0,0,1,1,.34,1.8,1.8,0,0,1,.59.9,5.12,5.12,0,0,1,.19,1.48,7.33,7.33,0,0,1-.29,2,8.25,8.25,0,0,1-.81,1.91,9,9,0,0,1-1.29,1.7,7.66,7.66,0,0,1-1.72,1.34,4.76,4.76,0,0,1-1.52.59,2.28,2.28,0,0,1-1.29-.12,1.83,1.83,0,0,1-.9-.82,3.31,3.31,0,0,1-.39-1.53,1,1,0,0,1,.11-.49.75.75,0,0,1,.28-.32l1-.58c.16-.09.29-.12.37-.08a.48.48,0,0,1,.22.27,1.82,1.82,0,0,0,.24.43.67.67,0,0,0,.38.28,1.21,1.21,0,0,0,.61,0,3.44,3.44,0,0,0,.9-.38,6.43,6.43,0,0,0,.82-.58,4,4,0,0,0,.7-.73,3.78,3.78,0,0,0,.48-.85,2.3,2.3,0,0,0,.19-1,.92.92,0,0,0-.2-.67.77.77,0,0,0-.6-.18,5.16,5.16,0,0,0-1,.17l-1.38.29a3.94,3.94,0,0,1-1.24.09,1.4,1.4,0,0,1-.88-.38,1.82,1.82,0,0,1-.52-.93,5.88,5.88,0,0,1-.17-1.6,7.12,7.12,0,0,1,.28-2,8.66,8.66,0,0,1,.78-1.88,8.94,8.94,0,0,1,1.19-1.61A6.66,6.66,0,0,1,230.22,114.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.83,121.81a1.2,1.2,0,0,1-.11.48.77.77,0,0,1-.27.33l-1.08.63a.21.21,0,0,1-.27,0,.45.45,0,0,1-.12-.35v-5.56a3.42,3.42,0,0,0-.39-1.88c-.27-.37-.68-.39-1.23-.08a2.92,2.92,0,0,0-1.19,1.48,6.19,6.19,0,0,0-.43,2.35v5.56a1.2,1.2,0,0,1-.11.48.77.77,0,0,1-.27.33l-1.08.63a.21.21,0,0,1-.27,0,.45.45,0,0,1-.12-.35V111.45A1.07,1.07,0,0,1,236,111a.66.66,0,0,1,.27-.33l1.08-.62a.2.2,0,0,1,.27,0,.49.49,0,0,1,.11.35v4.66a8.61,8.61,0,0,1,.87-1.44,3.81,3.81,0,0,1,1.18-1,2.4,2.4,0,0,1,1.45-.43,1.38,1.38,0,0,1,.94.58,3.38,3.38,0,0,1,.5,1.34,10.65,10.65,0,0,1,.15,1.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.72,112.73a6.14,6.14,0,0,1,.27-1.14,6.82,6.82,0,0,1,.58-1.32,7.44,7.44,0,0,1,.92-1.29,5.13,5.13,0,0,1,1.28-1,3.14,3.14,0,0,1,1.3-.46,1.41,1.41,0,0,1,1,.29,2,2,0,0,1,.64,1.06,6.05,6.05,0,0,1,.23,1.85v6.43a1.2,1.2,0,0,1-.11.48.75.75,0,0,1-.27.34l-1.08.62a.21.21,0,0,1-.27,0,.45.45,0,0,1-.12-.35v-.72a6.46,6.46,0,0,1-.86,1.58,4.5,4.5,0,0,1-1.43,1.27,2.46,2.46,0,0,1-1.09.38,1.12,1.12,0,0,1-.81-.24,1.7,1.7,0,0,1-.51-.79,3.94,3.94,0,0,1-.17-1.27,5.66,5.66,0,0,1,.69-2.77,8.19,8.19,0,0,1,1.86-2.23l2.32-2c0-.6-.12-1-.38-1a1.1,1.1,0,0,0-.95.18,1.65,1.65,0,0,0-.56.47,4.16,4.16,0,0,0-.38.64,2.39,2.39,0,0,1-.24.37.7.7,0,0,1-.23.2L245,113a.23.23,0,0,1-.25,0A.34.34,0,0,1,244.72,112.73Zm2.38,4.8a3.62,3.62,0,0,0,.86-.7,4.76,4.76,0,0,0,.63-.93,5,5,0,0,0,.39-1,4.22,4.22,0,0,0,.12-1v-.22l-1.93,1.64a3.67,3.67,0,0,0-.84.94,1.85,1.85,0,0,0-.26.94c0,.31.11.48.31.51A1.16,1.16,0,0,0,247.1,117.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.3,105.87a2.93,2.93,0,0,0-1.23,1.29,5,5,0,0,0-.38,2.11V115a1.28,1.28,0,0,1-.11.49.77.77,0,0,1-.27.33l-1.08.62a.21.21,0,0,1-.27,0,.45.45,0,0,1-.12-.35v-10.2a1.07,1.07,0,0,1,.12-.48.66.66,0,0,1,.27-.33l1.08-.63a.21.21,0,0,1,.27,0,.49.49,0,0,1,.11.35v.5a7.39,7.39,0,0,1,.79-1.26,3.88,3.88,0,0,1,1.1-.92l.64-.37c.11-.06.2-.06.27,0a.45.45,0,0,1,.12.35v1.44a1.07,1.07,0,0,1-.12.48.68.68,0,0,1-.27.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3,107.78a12.65,12.65,0,0,1,.25-2.45,11.53,11.53,0,0,1,.69-2.29,8.68,8.68,0,0,1,1.1-1.89,5.17,5.17,0,0,1,1.45-1.3,2.4,2.4,0,0,1,1.44-.38,1.72,1.72,0,0,1,1.1.57,3.3,3.3,0,0,1,.71,1.36,7.57,7.57,0,0,1,.25,2v1a1.07,1.07,0,0,1-.12.48.66.66,0,0,1-.27.33l-4.75,2.75a2,2,0,0,0,.14.8.9.9,0,0,0,.36.44.78.78,0,0,0,.53.09,1.74,1.74,0,0,0,.61-.22,3.21,3.21,0,0,0,.74-.57,3.44,3.44,0,0,0,.47-.63,3.43,3.43,0,0,1,.25-.39,1,1,0,0,1,.27-.22l1.14-.66a.22.22,0,0,1,.28,0,.4.4,0,0,1,.1.35,3.54,3.54,0,0,1-.22.92,6.25,6.25,0,0,1-.62,1.29,8.37,8.37,0,0,1-1,1.38,5.73,5.73,0,0,1-1.4,1.14,2.52,2.52,0,0,1-1.45.4,1.58,1.58,0,0,1-1.1-.58,3.6,3.6,0,0,1-.69-1.47A9.19,9.19,0,0,1,258.3,107.78Zm3.49-5.3a2.73,2.73,0,0,0-.71.59,4.09,4.09,0,0,0-.79,1.6,5.06,5.06,0,0,0-.14.77l3.22-1.86a4.76,4.76,0,0,0-.11-.62,1.07,1.07,0,0,0-.26-.51.63.63,0,0,0-.47-.21A1.37,1.37,0,0,0,261.79,102.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.95,
    cy: 152.16,
    rx: 14.97,
    ry: 8.47,
    transform: "translate(6.59 314.29) rotate(-66.95)",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.42,161.13l2.44-1.41v-8.15l1.71-1,.18-2.83-1.89,1.09v-1.56c0-.64.1-.95.57-1.22l1.32-.76v-2.84l-1.69,1a5,5,0,0,0-2.64,4.63v2.18l-1.27.73v2.76l1.27-.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.64,170l-15.38,8.88c-.86.49-1.55,0-1.55-1.18h0a3.69,3.69,0,0,1,1.55-3l15.38-8.88c.85-.49,1.55,0,1.55,1.17h0A3.73,3.73,0,0,1,248.64,170Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.17,
    cy: 129.52,
    rx: 14.97,
    ry: 8.47,
    transform: "translate(51.29 336.6) rotate(-66.95)",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.82,137.08a4.37,4.37,0,0,0,3.37-.63c4.07-2.35,6.37-8.26,6.23-12.29a11.42,11.42,0,0,0,1.09-2.15,7.4,7.4,0,0,1-1.26,1.19,5.68,5.68,0,0,0,1-2.17,8.78,8.78,0,0,1-1.39,1.51,1.34,1.34,0,0,0-1.6,0,5.18,5.18,0,0,0-2.14,4.82c-1.82.93-3.44.7-4.52-.44-.58,1.64-.3,3.2.68,3.51a1.6,1.6,0,0,1-1,.21c0,1.37.71,2.21,1.76,1.89a2.65,2.65,0,0,1-1,.62,1.29,1.29,0,0,0,2.05.85A7.56,7.56,0,0,1,274.82,137.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.86,147.31l-15.38,8.87c-.85.5-1.55,0-1.55-1.17h0a3.76,3.76,0,0,1,1.55-3l15.38-8.87c.85-.5,1.55,0,1.55,1.17h0A3.76,3.76,0,0,1,287.86,147.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.39,
    cy: 106.87,
    rx: 14.97,
    ry: 8.47,
    transform: "translate(95.99 358.92) rotate(-66.95)",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.39,100.86c1.47-.85,1.64-.94,2.22-1.24a2.63,2.63,0,0,1,1-.34.9.9,0,0,1,.64.19,1.17,1.17,0,0,1,.41.6,4.52,4.52,0,0,1,.19,1.26c0,.75,0,1,0,2.94s0,2.19,0,3a7.39,7.39,0,0,1-.19,1.47,4.54,4.54,0,0,1-.41,1.08,4.18,4.18,0,0,1-.64.92,4.6,4.6,0,0,1-1,.84c-.58.37-.75.48-2.22,1.33s-1.64.94-2.22,1.24a2.55,2.55,0,0,1-1,.33.85.85,0,0,1-.64-.18,1.16,1.16,0,0,1-.41-.61,4.35,4.35,0,0,1-.19-1.25c0-.76,0-1,0-2.94s0-2.2,0-3a7.65,7.65,0,0,1,.19-1.48,4.71,4.71,0,0,1,.41-1.08,4.35,4.35,0,0,1,.64-.91,4.6,4.6,0,0,1,1-.84c.58-.37.75-.48,2.22-1.33m0-1.32c-1.49.86-1.68,1-2.27,1.35a6.64,6.64,0,0,0-2.31,2.52,7.65,7.65,0,0,0-.63,1.67,8.75,8.75,0,0,0-.26,1.93c0,.79,0,1,0,3s0,2.24,0,3a5.36,5.36,0,0,0,.26,1.64,1.89,1.89,0,0,0,.63.93,1.41,1.41,0,0,0,1,.28,3.13,3.13,0,0,0,1.33-.43c.59-.3.78-.4,2.27-1.26s1.68-1,2.27-1.36a6.15,6.15,0,0,0,1.33-1.11,6.34,6.34,0,0,0,1-1.41,7.39,7.39,0,0,0,.63-1.66,8.83,8.83,0,0,0,.26-1.93c0-.8,0-1,0-3s0-2.24,0-3a5.34,5.34,0,0,0-.26-1.63,1.89,1.89,0,0,0-.63-.93,1.36,1.36,0,0,0-1-.28,3.13,3.13,0,0,0-1.33.43c-.59.3-.78.4-2.27,1.26",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.39,103.11a6.77,6.77,0,0,0-2.82,5.4c0,2.07,1.26,3,2.82,2.13a6.77,6.77,0,0,0,2.82-5.4c0-2.08-1.26-3-2.82-2.13m0,6.21c-1,.58-1.83,0-1.83-1.39a4.38,4.38,0,0,1,1.83-3.5c1-.58,1.83,0,1.83,1.39a4.4,4.4,0,0,1-1.83,3.5",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,100.88a1.58,1.58,0,0,1-.66,1.26c-.37.22-.66,0-.66-.49a1.59,1.59,0,0,1,.66-1.27c.36-.21.66,0,.66.5",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.08,124.66l-15.38,8.88c-.85.49-1.55,0-1.55-1.18h0a3.72,3.72,0,0,1,1.55-3l15.38-8.88c.85-.49,1.55,0,1.55,1.18h0A3.72,3.72,0,0,1,327.08,124.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.95,
    cy: 203.07,
    rx: 14.97,
    ry: 8.47,
    transform: "translate(-40.25 345.27) rotate(-66.95)",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,199.19c-.08-4.18-2.69-6.07-5.9-4.21s-5.77,6.64-5.91,10.88v.35a6.72,6.72,0,0,0,.85,3.55l-1.07,4.81,3.27-3.28a4.4,4.4,0,0,0,2.86-.67c3.26-1.89,5.91-6.91,5.91-11.23A1.27,1.27,0,0,0,247,199.19Zm-5.9,10.18a3.46,3.46,0,0,1-2.73.49l-1.91,1.91L237,209a5.24,5.24,0,0,1-.95-3.31c0-.22,0-.44,0-.66.25-3.46,2.37-7.3,4.95-8.78s4.75-.07,4.95,3.2c0,.16,0,.33,0,.5C246,203.56,243.8,207.79,241.06,209.37Z",
    style: {
      fill: "#fafafa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.77,202.81c-.15,0-.86-.06-1-.05s-.23,0-.33.29-.38.84-.46,1-.17.24-.31.23a2,2,0,0,1-1.17-.28,2.47,2.47,0,0,1-.8-.86c-.09-.14,0-.29.06-.43s.14-.3.22-.46l0-.12c0-.09.06-.17.09-.28a.4.4,0,0,0,0-.33c0-.08-.33-.85-.45-1.17s-.24-.17-.32-.13l-.28.15a1,1,0,0,0-.39.46,4.11,4.11,0,0,0-.5,1.89,2.84,2.84,0,0,0,.07.61,2.52,2.52,0,0,0,.52,1,3.11,3.11,0,0,0,2.47,1.47c1.48-.09,1.48-.34,1.74-.53a3.42,3.42,0,0,0,1-1.47,2.24,2.24,0,0,0,.08-1C244,202.82,243.91,202.83,243.77,202.81Z",
    style: {
      fill: "#fafafa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.64,221.22l-15.38,8.88c-.86.49-1.55,0-1.55-1.18h0a3.69,3.69,0,0,1,1.55-3l15.38-8.88c.85-.49,1.55,0,1.55,1.18h0A3.72,3.72,0,0,1,248.64,221.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.92,174.8c0,7.17-4.37,15.51-9.75,18.62s-9.75-.19-9.75-7.37,4.37-15.52,9.75-18.62S289.92,167.62,289.92,174.8Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,171.63l-11.58,6.69a1.12,1.12,0,0,0-.47.89v9.65c0,.35.21.5.47.35L286,182.53a1.12,1.12,0,0,0,.47-.89V172C286.43,171.64,286.22,171.49,286,171.63Zm-1.29,2-4.5,7.51-4.5-2.32Zm-9.83,14.09V180l5,2.6a.31.31,0,0,0,.29,0,.88.88,0,0,0,.29-.31l5-8.41v7.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.86,198.58l-15.38,8.87c-.85.5-1.55,0-1.55-1.17h0a3.76,3.76,0,0,1,1.55-3l15.38-8.87c.85-.5,1.55,0,1.55,1.17h0A3.74,3.74,0,0,1,287.86,198.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.39,
    cy: 157.78,
    rx: 14.97,
    ry: 8.47,
    transform: "translate(49.15 389.89) rotate(-66.95)",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.93,159.4l-2.33,4.92c-.39.83-1,1.2-1.43.82l-.35-.34a2.18,2.18,0,0,1,0-2.2l1.09-2.33a1.06,1.06,0,0,0,0-1.1c-.19-.19-.51,0-.71.41l-1.1,2.33a6.12,6.12,0,0,0-.59,2.54,2.59,2.59,0,0,0,.59,1.86l.36.34c.79.76,2.07,0,2.86-1.65l2.32-4.92a6.08,6.08,0,0,0,.59-2.54,2.59,2.59,0,0,0-.59-1.86l-.36-.34c-.19-.19-.51,0-.71.41a1.06,1.06,0,0,0,0,1.1l.36.35a2.22,2.22,0,0,1,0,2.2Zm-1.79-3.92a6.12,6.12,0,0,0-.59,2.54,2.59,2.59,0,0,0,.59,1.86c.2.19.52,0,.71-.42a1.06,1.06,0,0,0,0-1.1,2.22,2.22,0,0,1,0-2.2l2.33-4.91a1.88,1.88,0,0,1,.71-.87.57.57,0,0,1,.72,0l.35.35a1.23,1.23,0,0,1,.3.92A3,3,0,0,1,323,153l-1,2.12a1.06,1.06,0,0,0,0,1.1c.2.19.52,0,.72-.41l1-2.13a6.08,6.08,0,0,0,.59-2.54,2.59,2.59,0,0,0-.59-1.86l-.36-.34a1.12,1.12,0,0,0-1.43-.09,3.88,3.88,0,0,0-1.43,1.74l-2.32,4.92Zm0,0",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.08,175.93l-15.38,8.88c-.85.5-1.55,0-1.55-1.17h0a3.74,3.74,0,0,1,1.55-3l15.38-8.88c.85-.49,1.55,0,1.55,1.18h0A3.72,3.72,0,0,1,327.08,175.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.33,318.42a1.53,1.53,0,0,1-.73-.19,1.73,1.73,0,0,1-.79-1.57V260.08a4,4,0,0,1,1.84-3.19l87.84-50.71,4.44-16.52a1.94,1.94,0,0,1,3.68-.22l3.92,9.78,3.92-2.26a1.6,1.6,0,0,1,2.54,1.46V255a4,4,0,0,1-1.85,3.19l-103.8,59.93A2,2,0,0,1,226.33,318.42ZM320.8,189.6h0a.54.54,0,0,0-.51.41l-4.59,17.08-.24.14-88.09,50.86a2.64,2.64,0,0,0-1.15,2v56.58c0,.26.08.36.1.37s.14,0,.36-.11L330.45,257a2.63,2.63,0,0,0,1.15-2V198.42c0-.26-.07-.35-.09-.36s-.14,0-.37.1l-5.3,3.06L321.33,190A.56.56,0,0,0,320.8,189.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.79,281.78a1.43,1.43,0,0,1-.74-.19,1.73,1.73,0,0,1-.78-1.57V264a4,4,0,0,1,1.84-3.19l86.94-50.19a1.58,1.58,0,0,1,2.53,1.46v16a4,4,0,0,1-1.84,3.2L234.8,281.49A2,2,0,0,1,233.79,281.78Zm1-19.76a2.62,2.62,0,0,0-1.15,2v16a.56.56,0,0,0,.09.37s.14,0,.37-.1l86.94-50.19a2.65,2.65,0,0,0,1.15-2v-16c0-.26-.07-.36-.09-.37s-.14,0-.37.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.2,275.05V264.62a.8.8,0,0,1,.5-.7l.26-.15c.32-.19.48-.14.48.14v3.91a4.88,4.88,0,0,1,.52-1,2.1,2.1,0,0,1,.68-.68q.54-.3.84.06a2.37,2.37,0,0,1,.31,1.45V273a.86.86,0,0,1-.49.72l-.25.14c-.17.1-.3.14-.38.11s-.11-.11-.11-.26v-5c0-.64-.17-.87-.5-.68a1,1,0,0,0-.38.43,2.51,2.51,0,0,0-.24.6v5.27a.68.68,0,0,1-.12.4,1.08,1.08,0,0,1-.37.32l-.25.15C236.36,275.39,236.2,275.34,236.2,275.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.31,272.09a2.15,2.15,0,0,1-.33-1.44v-4.26l-.17.1c-.09.05-.16,0-.2,0a1.07,1.07,0,0,1-.06-.45v-.23a1.84,1.84,0,0,1,.06-.53.45.45,0,0,1,.2-.26l.17-.1.13-1.54a.82.82,0,0,1,.45-.69l.23-.13c.28-.16.42-.1.42.19v1.46l.45-.26c.09-.05.16,0,.2,0a1.16,1.16,0,0,1,.06.46v.23a1.76,1.76,0,0,1-.06.52.44.44,0,0,1-.2.27l-.45.26v4.23a1,1,0,0,0,.07.47c.05.08.12.09.21,0a.83.83,0,0,0,.16-.13l.13-.1q.1-.06.18.27a2.54,2.54,0,0,1,.08.52,1,1,0,0,1-.29.64,2.66,2.66,0,0,1-.59.5A.64.64,0,0,1,241.31,272.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.2,270.42a2.15,2.15,0,0,1-.33-1.44v-4.26l-.17.1c-.09.05-.16,0-.2,0a1.16,1.16,0,0,1-.06-.46v-.23a1.76,1.76,0,0,1,.06-.52.44.44,0,0,1,.2-.27l.17-.1.13-1.54a.82.82,0,0,1,.45-.69l.23-.13c.28-.16.42-.1.42.19v1.46l.45-.26c.09-.05.16,0,.2,0a1.16,1.16,0,0,1,.06.46V263a1.76,1.76,0,0,1-.06.52.44.44,0,0,1-.2.27l-.45.26v4.23a1,1,0,0,0,.07.47c.05.08.12.09.21,0a.61.61,0,0,0,.16-.13l.13-.1q.11-.06.18.27a2.54,2.54,0,0,1,.08.52,1,1,0,0,1-.29.65,2.65,2.65,0,0,1-.59.49A.64.64,0,0,1,244.2,270.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.69,272.06v-8c0-.68,0-1.16-.05-1.45s-.06-.47-.06-.54.11-.3.33-.51a3.39,3.39,0,0,1,.57-.44c.12-.07.2,0,.25.1a4.43,4.43,0,0,1,.12.63,4.52,4.52,0,0,1,.45-1,1.91,1.91,0,0,1,.62-.64.61.61,0,0,1,.78,0,2,2,0,0,1,.52,1.09,9.77,9.77,0,0,1,.18,2.06,10.08,10.08,0,0,1-.43,3.19,3,3,0,0,1-1.18,1.72.66.66,0,0,1-.87,0v3.1a.84.84,0,0,1-.51.72l-.22.13C246.86,272.39,246.69,272.35,246.69,272.06Zm2.29-6a8.35,8.35,0,0,0,.17-2c0-1.65-.2-2.35-.61-2.12a1.91,1.91,0,0,0-.62,1.11v3.82a.38.38,0,0,0,.54.06A1.29,1.29,0,0,0,249,266.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.07,260.7v-1.24a.84.84,0,0,1,.5-.72l.27-.16c.33-.19.49-.14.49.15V260a.81.81,0,0,1-.49.7l-.27.16C251.24,261,251.07,261,251.07,260.7Zm0,5.76v-1.24a.82.82,0,0,1,.5-.7l.27-.16c.33-.19.49-.14.49.13v1.24a.82.82,0,0,1-.49.72l-.27.16C251.24,266.8,251.07,266.75,251.07,266.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.45,266.92a2.12,2.12,0,0,1,0-.27l2.31-12a.9.9,0,0,1,.45-.64l.19-.12c.23-.13.34-.09.34.12,0,0,0,.13,0,.29l-2.31,12a.93.93,0,0,1-.45.66l-.18.1C252.57,267.17,252.45,267.13,252.45,266.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.56,265.13a2.12,2.12,0,0,1,0-.27l2.3-12a.94.94,0,0,1,.45-.65l.19-.11c.23-.13.34-.09.34.12,0,0,0,.12,0,.29l-2.31,12a.9.9,0,0,1-.45.66l-.18.11C255.67,265.38,255.56,265.34,255.56,265.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.72,261.47a2.08,2.08,0,0,1-.32-1.41v-8.83a.85.85,0,0,1,.51-.72l.2-.11q.51-.3.51.12v8.82a.83.83,0,0,0,.07.43c0,.07.11.08.2,0a.45.45,0,0,0,.14-.11l.11-.09q.12-.06.18.24a2.51,2.51,0,0,1,.08.57.94.94,0,0,1-.26.61,2.14,2.14,0,0,1-.57.48C260.22,261.69,259.93,261.69,259.72,261.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.07,260.12v-7a.86.86,0,0,1,.51-.73l.19-.11c.35-.2.52-.15.52.13v7a.85.85,0,0,1-.52.73l-.19.11C262.24,260.45,262.07,260.41,262.07,260.12Zm0-8.84v-.84c0-.29.2-.54.59-.77s.59-.19.59.1v.83c0,.29-.2.55-.58.77S262.1,251.57,262.1,251.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.49,258.72v-4.93c0-.69,0-1.17-.05-1.46s-.05-.44-.05-.49a.83.83,0,0,1,.34-.54,2.8,2.8,0,0,1,.59-.45c.11-.07.18,0,.22,0a1.14,1.14,0,0,1,.08.38c0,.16,0,.28.05.37a5.18,5.18,0,0,1,.53-1.11,2.18,2.18,0,0,1,.72-.73c.37-.22.66-.2.85.06a2.51,2.51,0,0,1,.29,1.45v5.34a.82.82,0,0,1-.49.72l-.25.14c-.33.2-.5.15-.5-.14v-5a1.44,1.44,0,0,0-.11-.67c-.08-.12-.2-.13-.37,0a1,1,0,0,0-.34.39,2.88,2.88,0,0,0-.28.64V258a.68.68,0,0,1-.12.4,1,1,0,0,1-.37.32l-.25.15C264.65,259.05,264.49,259,264.49,258.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.86,254.1c0,.15-.16.31-.46.48l-.43.25a.42.42,0,0,1-.25.09s-.08,0-.11-.14l-1.08-2.88-.1.06v3.33a.81.81,0,0,1-.49.71l-.24.14c-.33.19-.49.14-.49-.15V245.57a.82.82,0,0,1,.49-.71l.24-.14c.33-.18.49-.14.49.14v6.38l.05,0,1-3.73a.73.73,0,0,1,.13-.28.94.94,0,0,1,.25-.2l.4-.23c.31-.17.46-.18.46,0a1.3,1.3,0,0,1-.07.35l-1.09,3.83,1.21,2.92A.74.74,0,0,1,272.86,254.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.25,253.66v-1.24a.84.84,0,0,1,.5-.71l.27-.15c.33-.19.49-.15.49.13v1.24a.82.82,0,0,1-.49.72l-.27.15C273.42,254,273.25,254,273.25,253.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,251.73a.89.89,0,0,1-.47-.5l-.08.72a.72.72,0,0,1-.15.33,1.35,1.35,0,0,1-.31.25l-.1.05q-.48.28-.48-.15V242a.85.85,0,0,1,.5-.71l.22-.12c.33-.19.5-.15.5.13v3.46a2.33,2.33,0,0,1,.88-1.06.77.77,0,0,1,1.19.36,6.22,6.22,0,0,1,.42,2.71,13,13,0,0,1-.18,2.26,6.37,6.37,0,0,1-.52,1.69,2.23,2.23,0,0,1-.79.94A.72.72,0,0,1,277,251.73Zm.72-2.28a9.74,9.74,0,0,0,.15-2,6,6,0,0,0-.17-1.79c-.11-.32-.28-.41-.52-.27a1.49,1.49,0,0,0-.55.69V250c.19.35.39.46.62.33A1.23,1.23,0,0,0,277.69,249.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.37,249.06a4.72,4.72,0,0,1-.52-2.66q0-4.07,2-5.21c1.18-.68,1.77.31,1.77,2.95a1.92,1.92,0,0,1-.17.58,1.31,1.31,0,0,1-.27.47l-2,1.18a2.35,2.35,0,0,0,.25,1.19c.15.18.37.2.65,0a1.59,1.59,0,0,0,.45-.37,5.19,5.19,0,0,0,.36-.46,1.43,1.43,0,0,1,.19-.25c.09,0,.18,0,.29.23a1.09,1.09,0,0,1,.16.51,1.22,1.22,0,0,1-.24.65,3.83,3.83,0,0,1-.59.71,3,3,0,0,1-.66.51C281.25,249.55,280.72,249.53,280.37,249.06Zm2.07-4.7a5.16,5.16,0,0,0-.15-1.51c-.1-.28-.26-.36-.48-.23a1.22,1.22,0,0,0-.51.78,7.51,7.51,0,0,0-.22,1.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.71,248.87a2.12,2.12,0,0,1,0-.27l2.31-12a.92.92,0,0,1,.45-.64l.19-.11c.23-.13.34-.1.34.11,0,0,0,.13,0,.29l-2.31,12a1,1,0,0,1-.44.66l-.19.1C283.83,249.12,283.71,249.08,283.71,248.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,245.83s0-.12,0-.26l1.59-10.51a1,1,0,0,1,.52-.68l.52-.29c.31-.18.49-.16.53.06l1.58,8.68a1.5,1.5,0,0,1,0,.24c0,.2-.13.37-.39.53l-.39.22c-.28.16-.43.16-.46,0l-.31-1.87-1.69,1-.31,2.23a.72.72,0,0,1-.41.52l-.39.22C287.18,246.05,287,246,287,245.83Zm3-5.37-.53-3.18c0-.29-.08-.62-.11-1l-.05,0c0,.41-.07.79-.12,1.13l-.51,3.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.73,233.54a2.38,2.38,0,0,1,0,.28L294,244.87a.91.91,0,0,1-.49.6l-.19.11c-.31.18-.47.17-.47,0t0-.27l.6-3.62a.21.21,0,0,1-.17,0s-.07-.06-.09-.15L292,236a1.08,1.08,0,0,1,0-.3q0-.3.45-.57l.31-.18a.64.64,0,0,1,.31-.11c.08,0,.12.06.13.17l.49,3.1c0,.33.1.8.16,1.41l.05,0c0-.15,0-.38.07-.69,0-.16,0-.46.1-.91l.5-3.7a.8.8,0,0,1,.45-.55l.23-.13C295.57,233.33,295.73,233.34,295.73,233.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.82,239.26a7.47,7.47,0,0,1-.61-3.7,12.41,12.41,0,0,1,.64-4.37,4.61,4.61,0,0,1,2-2.45,2.1,2.1,0,0,1,.89-.32.21.21,0,0,1,.21.11.89.89,0,0,1,0,.36,3.59,3.59,0,0,1-.11.91c-.07.31-.17.45-.28.44a1.21,1.21,0,0,0-.7.2,2.35,2.35,0,0,0-1,1.46,10.66,10.66,0,0,0-.32,2.9,7,7,0,0,0,.32,2.54.64.64,0,0,0,1,.29,2.07,2.07,0,0,0,.37-.27,4.58,4.58,0,0,0,.36-.38l.09-.08c.11-.06.2,0,.25.19a2.66,2.66,0,0,1,.09.77,1.52,1.52,0,0,1-.05.38,1.09,1.09,0,0,1-.21.35,3.63,3.63,0,0,1-.44.43,3.73,3.73,0,0,1-.57.41C297.89,239.94,297.24,239.89,296.82,239.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,236.77a9.48,9.48,0,0,1-.5-3.69,14.79,14.79,0,0,1,.5-4.26,3.58,3.58,0,0,1,1.45-2.2c.63-.36,1.11-.19,1.45.52a9.35,9.35,0,0,1,.51,3.68,14.78,14.78,0,0,1-.51,4.27,3.66,3.66,0,0,1-1.45,2.2C301.85,237.65,301.37,237.48,301,236.77Zm1.82-1.54a5.38,5.38,0,0,0,.23-1.29c.06-.59.09-1.39.09-2.38a21.82,21.82,0,0,0-.09-2.29,2.77,2.77,0,0,0-.23-1,.24.24,0,0,0-.37-.11.92.92,0,0,0-.38.55,5.38,5.38,0,0,0-.23,1.29c-.05.59-.08,1.39-.08,2.38s0,1.76.08,2.29a2.77,2.77,0,0,0,.23,1,.25.25,0,0,0,.38.11A1,1,0,0,0,302.86,235.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.23,234v-1.85l-2.13,1.23c-.07,0-.14-.07-.21-.31a2.54,2.54,0,0,1-.1-.68.91.91,0,0,1,0-.17l2.27-7.91a.69.69,0,0,1,.18-.34,1.1,1.1,0,0,1,.33-.25l.39-.23q.48-.27.48.15V230l.36-.2c.09-.06.16,0,.2,0a1.16,1.16,0,0,1,.06.46v.22a1.79,1.79,0,0,1-.06.53.42.42,0,0,1-.2.26l-.36.21v1.85a.83.83,0,0,1-.48.72l-.25.14C307.39,234.38,307.23,234.33,307.23,234Zm0-3.36v-2c0-.62,0-1.3.09-2h0L306,231.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,231.62a9.58,9.58,0,0,1-.5-3.68,15.1,15.1,0,0,1,.5-4.26,3.66,3.66,0,0,1,1.45-2.2c.64-.37,1.12-.19,1.46.52a9.58,9.58,0,0,1,.5,3.68,15.23,15.23,0,0,1-.5,4.27,3.57,3.57,0,0,1-1.46,2.19C310.76,232.51,310.28,232.34,309.94,231.62Zm1.83-1.53a6.06,6.06,0,0,0,.23-1.3c.06-.59.08-1.38.08-2.38a22.3,22.3,0,0,0-.08-2.28,3,3,0,0,0-.23-1,.25.25,0,0,0-.38-.11,1,1,0,0,0-.38.54,6.19,6.19,0,0,0-.22,1.3c-.06.59-.09,1.38-.09,2.38a21.47,21.47,0,0,0,.09,2.28,3.14,3.14,0,0,0,.22,1,.25.25,0,0,0,.38.11A1,1,0,0,0,311.77,230.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.26,230.15a1,1,0,0,1,0-.16.64.64,0,0,0,0-.15l2.17-9.68-2.29,1.32c-.09.06-.16.05-.2,0a1.13,1.13,0,0,1-.06-.46v-.22a1.79,1.79,0,0,1,.06-.53.45.45,0,0,1,.2-.26l3.37-1.95c.05,0,.1.08.17.32a2.79,2.79,0,0,1,.1.66,1.49,1.49,0,0,1,0,.21l-2.27,10.18a.92.92,0,0,1-.5.57l-.28.16C314.42,230.32,314.26,230.33,314.26,230.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47,277.92a1.49,1.49,0,0,1-.74-.2,1.73,1.73,0,0,1-.78-1.56V262.91a4,4,0,0,1,1.84-3.19l35.26-20.36a1.58,1.58,0,0,1,2.53,1.46v13.24a4,4,0,0,1-1.84,3.2l-35.25,20.36A2.05,2.05,0,0,1,285.47,277.92Zm36.59-37.48a.66.66,0,0,0-.32.12l-35.25,20.36a2.62,2.62,0,0,0-1.16,2v13.25a.52.52,0,0,0,.1.37.56.56,0,0,0,.36-.11l35.26-20.36a2.65,2.65,0,0,0,1.15-2V240.82c0-.26-.07-.36-.09-.37Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.64,263a.71.71,0,0,1,.06-.22.31.31,0,0,1,.12-.13l.51-.3a.13.13,0,0,1,.12,0s.05.09.05.17a4.83,4.83,0,0,1-.13.87,3.74,3.74,0,0,1-.34.91,4.21,4.21,0,0,1-.57.85,3.28,3.28,0,0,1-.83.69,1.65,1.65,0,0,1-.77.24.85.85,0,0,1-.57-.22,1.56,1.56,0,0,1-.36-.64,3.56,3.56,0,0,1-.15-1c0-.24,0-.51,0-.81s0-.57,0-.82a5.67,5.67,0,0,1,.15-1.16,5.74,5.74,0,0,1,.36-1.06,4.43,4.43,0,0,1,.57-.88,3,3,0,0,1,.77-.64,1.69,1.69,0,0,1,.83-.28.9.9,0,0,1,.57.2,1,1,0,0,1,.34.52,2.86,2.86,0,0,1,.13.72.41.41,0,0,1-.05.21.31.31,0,0,1-.12.15l-.51.29a.13.13,0,0,1-.12,0s-.06-.07-.07-.15a.9.9,0,0,0-.09-.33.44.44,0,0,0-.18-.22.51.51,0,0,0-.31-.06,1.07,1.07,0,0,0-.42.15,1.53,1.53,0,0,0-.43.37,2.19,2.19,0,0,0-.31.48,3.29,3.29,0,0,0-.19.58,3.17,3.17,0,0,0-.07.61c0,.25,0,.53,0,.82s0,.57,0,.81a2.06,2.06,0,0,0,.07.53.89.89,0,0,0,.19.35.5.5,0,0,0,.31.14.94.94,0,0,0,.43-.13,2,2,0,0,0,.42-.34,2.39,2.39,0,0,0,.31-.42,2.44,2.44,0,0,0,.19-.44A1.74,1.74,0,0,0,298.64,263Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.09,260.11a5.8,5.8,0,0,1,.13-1.1,4.79,4.79,0,0,1,.34-1,3.75,3.75,0,0,1,.57-.89,3,3,0,0,1,.81-.68,1.56,1.56,0,0,1,.79-.25.78.78,0,0,1,.57.23,1.46,1.46,0,0,1,.35.63,3.76,3.76,0,0,1,.13,1c0,.12,0,.25,0,.4v.92c0,.15,0,.29,0,.41a6,6,0,0,1-.13,1.11,5.18,5.18,0,0,1-.34,1,3.9,3.9,0,0,1-.57.88,3.21,3.21,0,0,1-.8.67,1.68,1.68,0,0,1-.81.26.82.82,0,0,1-.57-.23,1.44,1.44,0,0,1-.34-.64,3.68,3.68,0,0,1-.13-.94c0-.12,0-.25,0-.4s0-.3,0-.46,0-.31,0-.46S300.08,260.23,300.09,260.11Zm2.85-1.6a1.23,1.23,0,0,0-.3-.91c-.17-.15-.41-.14-.7,0a1.8,1.8,0,0,0-.71.8,3,3,0,0,0-.3,1.24c0,.25,0,.53,0,.83s0,.57,0,.81a1.23,1.23,0,0,0,.3.91c.18.15.41.14.71,0a1.76,1.76,0,0,0,.7-.79,3,3,0,0,0,.3-1.24c0-.25,0-.53,0-.83S302.94,258.75,302.94,258.51Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.47,253.89c.51-.29.9-.33,1.18-.13a1.69,1.69,0,0,1,.43,1.38,4,4,0,0,1-.43,1.87,3,3,0,0,1-1.18,1.24l-1,.58V261a.41.41,0,0,1,0,.21.24.24,0,0,1-.12.15l-.51.3a.09.09,0,0,1-.11,0,.21.21,0,0,1-.05-.16v-6.26a.41.41,0,0,1,.05-.21.27.27,0,0,1,.11-.14Zm-1,3.73,1-.56a1.58,1.58,0,0,0,.57-.55,1.66,1.66,0,0,0,.22-.88c0-.37-.08-.57-.22-.63a.66.66,0,0,0-.57.12l-1,.56Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,250.72a.09.09,0,0,1,.12,0,.17.17,0,0,1,.05.15.31.31,0,0,1,0,.1l-1.49,4.9V258a.54.54,0,0,1-.05.21.27.27,0,0,1-.12.15l-.5.29a.09.09,0,0,1-.12,0,.17.17,0,0,1,0-.15v-2.13l-1.49-3.18a.19.19,0,0,1,0-.08.63.63,0,0,1,.05-.22.35.35,0,0,1,.12-.14l.47-.27c.09,0,.15-.06.19,0a.33.33,0,0,1,.08.11l1,2.15,1-3.33a.64.64,0,0,1,.07-.19.48.48,0,0,1,.19-.21Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.79,307.65a1.43,1.43,0,0,1-.74-.19,1.73,1.73,0,0,1-.78-1.57V292.65a4,4,0,0,1,1.84-3.2l35.26-20.36a1.73,1.73,0,0,1,1.75-.1,1.71,1.71,0,0,1,.78,1.56V283.8a4,4,0,0,1-1.84,3.19L234.8,307.35A2,2,0,0,1,233.79,307.65Zm36.59-37.47a.72.72,0,0,0-.32.11L234.8,290.65a2.65,2.65,0,0,0-1.15,2v13.24a.58.58,0,0,0,.09.37s.17,0,.37-.11l35.26-20.36a2.64,2.64,0,0,0,1.15-2V270.55c0-.26-.07-.35-.09-.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.86,295.14a.71.71,0,0,1,.06-.22.31.31,0,0,1,.12-.13l.51-.3a.13.13,0,0,1,.12,0s.05.09.05.17a4.08,4.08,0,0,1-.13.87,4.17,4.17,0,0,1-.33.91,4.74,4.74,0,0,1-.58.85,3.28,3.28,0,0,1-.83.69,1.65,1.65,0,0,1-.77.24.85.85,0,0,1-.57-.22,1.56,1.56,0,0,1-.36-.64,3.56,3.56,0,0,1-.15-1c0-.24,0-.51,0-.81s0-.57,0-.82a5.67,5.67,0,0,1,.15-1.16,5.74,5.74,0,0,1,.36-1.06,4.43,4.43,0,0,1,.57-.88,3,3,0,0,1,.77-.64,1.69,1.69,0,0,1,.83-.28,1,1,0,0,1,.58.2,1.06,1.06,0,0,1,.33.52,2.48,2.48,0,0,1,.13.72.41.41,0,0,1-.05.21.31.31,0,0,1-.12.15l-.51.29a.11.11,0,0,1-.12,0s-.06-.07-.07-.15a.9.9,0,0,0-.09-.33.44.44,0,0,0-.18-.22.51.51,0,0,0-.31-.06,1.07,1.07,0,0,0-.42.15,1.53,1.53,0,0,0-.43.37,2.19,2.19,0,0,0-.31.48,3.29,3.29,0,0,0-.19.58,3.17,3.17,0,0,0-.07.61c0,.25,0,.53,0,.82s0,.57,0,.81a2.06,2.06,0,0,0,.07.53.89.89,0,0,0,.19.35.5.5,0,0,0,.31.14.94.94,0,0,0,.43-.13,2,2,0,0,0,.42-.34,2.39,2.39,0,0,0,.31-.42,2.44,2.44,0,0,0,.19-.44A1.74,1.74,0,0,0,242.86,295.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.48,288.42q.11-.06.15,0a.34.34,0,0,1,.09.19l1.54,5.24s0,0,0,.06a.54.54,0,0,1-.05.21.31.31,0,0,1-.12.15l-.45.26c-.09.05-.15.06-.18,0a.37.37,0,0,1-.07-.12l-.27-.92-2,1.15-.27,1.23a.6.6,0,0,1-.07.2.37.37,0,0,1-.17.18l-.46.27a.11.11,0,0,1-.12,0,.25.25,0,0,1-.05-.16s0-.05,0-.07l1.54-7a2.25,2.25,0,0,1,.09-.3.35.35,0,0,1,.15-.17Zm.35,4.05-.69-2.36-.7,3.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.7,292.19a.15.15,0,0,1-.17,0l-.08-.09-1.76-3v4a.54.54,0,0,1-.05.21.31.31,0,0,1-.12.15l-.51.29s-.08,0-.12,0a.21.21,0,0,1,0-.15v-6.26a.54.54,0,0,1,0-.21A.38.38,0,0,1,249,287l.44-.25c.07,0,.13,0,.17,0l.08.09,1.76,3v-4a.54.54,0,0,1,0-.21.31.31,0,0,1,.12-.15l.51-.29a.09.09,0,0,1,.12,0,.25.25,0,0,1,.05.16v6.26a.54.54,0,0,1-.05.21.49.49,0,0,1-.12.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,287.56a.52.52,0,0,1,.07-.23.38.38,0,0,1,.12-.13l.51-.29a.09.09,0,0,1,.12,0s.05.08.05.16a5.92,5.92,0,0,1-.13.87,4.57,4.57,0,0,1-.34.91,4.28,4.28,0,0,1-.57.86,3.13,3.13,0,0,1-.84.68,1.54,1.54,0,0,1-.77.25.81.81,0,0,1-.56-.23,1.32,1.32,0,0,1-.36-.64,3.93,3.93,0,0,1-.16-1c0-.24,0-.51,0-.81s0-.57,0-.82a6.35,6.35,0,0,1,.16-1.16,4.41,4.41,0,0,1,.36-1.06,3.77,3.77,0,0,1,.56-.88,2.92,2.92,0,0,1,.77-.64,1.76,1.76,0,0,1,.84-.28.84.84,0,0,1,.57.19,1.19,1.19,0,0,1,.34.53,3.19,3.19,0,0,1,.13.71.42.42,0,0,1-.05.22.35.35,0,0,1-.12.14l-.51.3a.13.13,0,0,1-.12,0s-.06-.07-.07-.15a.8.8,0,0,0-.09-.32.52.52,0,0,0-.19-.22.48.48,0,0,0-.3-.07,1.21,1.21,0,0,0-.43.16,1.62,1.62,0,0,0-.43.36,2.22,2.22,0,0,0-.3.49,2.73,2.73,0,0,0-.19.57,4.38,4.38,0,0,0-.08.62c0,.25,0,.52,0,.82s0,.57,0,.81a2.69,2.69,0,0,0,.08.53.78.78,0,0,0,.19.35.42.42,0,0,0,.3.13.71.71,0,0,0,.43-.13,1.62,1.62,0,0,0,.43-.34,2.94,2.94,0,0,0,.31-.41,2.44,2.44,0,0,0,.19-.44A2.31,2.31,0,0,0,256,287.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.52,285.89q.08,0,.12,0a.21.21,0,0,1,.05.16v.69a.41.41,0,0,1-.05.21.24.24,0,0,1-.12.14l-2.76,1.6a.09.09,0,0,1-.12,0,.21.21,0,0,1-.05-.15v-6.26a.54.54,0,0,1,.05-.21.39.39,0,0,1,.12-.15l2.71-1.57a.1.1,0,0,1,.12,0,.21.21,0,0,1,.05.16v.69a.41.41,0,0,1-.05.21.24.24,0,0,1-.12.14l-2,1.18v1.54l1.9-1.1a.09.09,0,0,1,.11,0,.21.21,0,0,1,.06.16V284a.42.42,0,0,1-.06.21.37.37,0,0,1-.11.15l-1.9,1.09v1.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.4,283.65c.05,0,.09,0,.12,0a.21.21,0,0,1,.05.15v.69a.54.54,0,0,1-.05.21.31.31,0,0,1-.12.15l-2.76,1.59a.09.09,0,0,1-.12,0,.21.21,0,0,1,0-.15V280a.63.63,0,0,1,0-.22.35.35,0,0,1,.12-.14l.51-.3a.1.1,0,0,1,.12,0,.21.21,0,0,1,.05.16v5.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.54,57.84,337,51.18a1,1,0,0,0-1.73-.9L332,56.65l-3-2.23a1,1,0,0,0-1.37.19,1,1,0,0,0,.19,1.36l3.21,2.43-3.48,6.66a1,1,0,0,0,.41,1.31.92.92,0,0,0,.45.12,1,1,0,0,0,.86-.53l3.34-6.37,2.95,2.23a1,1,0,0,0,.58.2,1,1,0,0,0,.78-.39,1,1,0,0,0-.19-1.36Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.55,409.84l3.56-2.06a4.36,4.36,0,0,1,3.93-.07,1.3,1.3,0,0,1,.75,1.06v1.57a1.5,1.5,0,0,1-.88,1.18l-3.55,2.05a4.36,4.36,0,0,1-3.93.07,1.29,1.29,0,0,1-.75-1.05c0-.27,0-1.31,0-1.58A1.48,1.48,0,0,1,436.55,409.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.91,410l-3.55,2a4.36,4.36,0,0,1-3.93.08c-1.05-.61-1-1.63.12-2.27l3.56-2.06a4.36,4.36,0,0,1,3.93-.07C445.09,408.32,445,409.33,443.91,410Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.47,424.3l3.55-2.05a4.33,4.33,0,0,1,3.93-.07,1.28,1.28,0,0,1,.75,1.05v1.57a1.49,1.49,0,0,1-.87,1.18l-3.56,2a4.36,4.36,0,0,1-3.93.08,1.26,1.26,0,0,1-.74-1.05c0-.27,0-1.31,0-1.59A1.51,1.51,0,0,1,411.47,424.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.83,424.45l-3.56,2.05a4.33,4.33,0,0,1-3.93.07c-1-.6-1-1.62.13-2.27l3.55-2.05a4.33,4.33,0,0,1,3.93-.07C420,422.78,420,423.8,418.83,424.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.32,389l3.55-2.05a4.33,4.33,0,0,1,3.93-.07,1.25,1.25,0,0,1,.75,1.05c0,.27,0,1.3,0,1.57a1.49,1.49,0,0,1-.87,1.18l-3.56,2.05a4.36,4.36,0,0,1-3.93.08,1.29,1.29,0,0,1-.74-1.05c0-.27,0-1.31,0-1.59A1.49,1.49,0,0,1,400.32,389Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.68,389.16l-3.56,2a4.33,4.33,0,0,1-3.93.07c-1.05-.61-1-1.62.13-2.27l3.55-2.05a4.33,4.33,0,0,1,3.93-.07C408.86,387.49,408.8,388.51,407.68,389.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.23,403.48l3.56-2.05a4.36,4.36,0,0,1,3.93-.08,1.27,1.27,0,0,1,.74,1.06c0,.27,0,1.29,0,1.57a1.46,1.46,0,0,1-.87,1.18l-3.55,2a4.35,4.35,0,0,1-3.94.07,1.27,1.27,0,0,1-.74-1c0-.27,0-1.31,0-1.58A1.48,1.48,0,0,1,375.23,403.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.59,403.62,379,405.68a4.41,4.41,0,0,1-3.94.07c-1.05-.61-1-1.63.13-2.27l3.56-2.05a4.36,4.36,0,0,1,3.93-.08C383.77,402,383.71,403,382.59,403.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.29,410.41a2.79,2.79,0,0,1-1.48-.41,3.56,3.56,0,0,1-1.35-3.49l11-133.78,1.87.15-11,133.79c-.07.85.11,1.51.48,1.74s1.05.12,1.79-.31l39.53-22.82a7.74,7.74,0,0,0,3.46-6.19l-3.68-125,1.88-.05,3.67,125a9.51,9.51,0,0,1-4.39,7.86l-39.53,22.83A4.64,4.64,0,0,1,367.29,410.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.53,
    y: 358.48,
    width: 1.87,
    height: 39.04,
    transform: "translate(-134.62 522.82) rotate(-60)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.49,
    y: 334.48,
    width: 1.87,
    height: 39.09,
    transform: "translate(-92.38 548.04) rotate(-60)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.44,431.29a2.93,2.93,0,0,1-1.51-.41,3.66,3.66,0,0,1-1.56-3.45l3.68-138.17,1.88.05-3.68,138.16a1.5,1.5,0,0,0,2.52,1.51l39.54-22.82A7.12,7.12,0,0,0,447.5,400l-11-129.39,1.87-.16,11,129.39a8.93,8.93,0,0,1-4.13,7.9L405.71,430.6A4.56,4.56,0,0,1,403.44,431.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380,258.79c14.87-8.59,39-8.59,53.83,0,7.44,4.29,11.15,9.91,11.14,15.54v6.9c0,5.63-3.71,11.25-11.14,15.54-14.86,8.59-39,8.59-53.83,0-7.43-4.29-11.14-9.91-11.14-15.54v-6.9C368.86,268.7,372.57,263.08,380,258.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,255.43c14.87-8.58,39-8.58,53.83,0C441.27,259.72,445,265.35,445,271v6.91c0,5.62-3.71,11.25-11.14,15.54-14.86,8.58-39,8.58-53.83,0-7.43-4.29-11.14-9.92-11.14-15.54V271C368.86,265.35,372.57,259.72,380,255.43Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,255.43c14.87-8.58,39-8.58,53.83,0C441.27,259.72,445,265.35,445,271v6.91c0,5.62-3.71,11.25-11.14,15.54-14.86,8.58-39,8.58-53.83,0-7.43-4.29-11.14-9.92-11.14-15.54V271C368.86,265.35,372.57,259.72,380,255.43Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.92,
    cy: 270.97,
    rx: 38.06,
    ry: 21.98,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.92,
    cy: 270.97,
    rx: 38.06,
    ry: 21.98,
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.12,321.19s9.41,14.7,11.17,20.89c1.84,6.45,3.91,8.25,4.43,15.6.11,1.6,0,4.89.09,6.19A1.9,1.9,0,0,0,377,365.8c3-.06,6.45-6.46,7.36-12.76a174.75,174.75,0,0,0,.94-21.69,9.06,9.06,0,0,0-1.94-4.36,13.9,13.9,0,0,0-1.84-2.07c-1.59-2.63-3.27-7.93-4.92-11.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.22,336a7,7,0,0,1,1.25,2c.36,1.28-1.59,6.24-2.39,8.07a10.69,10.69,0,0,0-.43,7.9c1.13,4.13.2,8.56-1.7,12.62a29.39,29.39,0,0,1-12.11,12.57c-6.39,3.69-9.6.8-9.6.8s-2.89-2.83-1.92-4.48S392.22,336,392.22,336Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.54,324.92c.21-.06.56-.2,1.25.32.26.2,2.22,3,3.63,4.39s4.85,3.84,5.8,6.4c-.42,5.46-4.39,10.1-4,15.08s1.58,10.58-4.47,18.16-13.51,9.92-16.6,9-3.51-3.92-1-10.37c2.69-6.84,2.48-20.28,2.48-20.29a44.15,44.15,0,0,0-.53-5.62c-.26-1.78-1.2-3.54-1.74-5.28a4.07,4.07,0,0,1-.22-2.52,4.28,4.28,0,0,1,1.71-1.87,18.41,18.41,0,0,1,3.51-2.16,6.21,6.21,0,0,1,4-.42,29.22,29.22,0,0,0,2.8,1,3.61,3.61,0,0,0,3.49-1.48,3.08,3.08,0,0,0,.21-3.56A7.79,7.79,0,0,0,381.54,324.92Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.54,324.92c.21-.06.56-.2,1.25.32.26.2,2.22,3,3.63,4.39s4.85,3.84,5.8,6.4c-.42,5.46-4.39,10.1-4,15.08s1.58,10.58-4.47,18.16-13.51,9.92-16.6,9-3.51-3.92-1-10.37c2.69-6.84,2.48-20.28,2.48-20.29a44.15,44.15,0,0,0-.53-5.62c-.26-1.78-1.2-3.54-1.74-5.28a4.07,4.07,0,0,1-.22-2.52,4.28,4.28,0,0,1,1.71-1.87,18.41,18.41,0,0,1,3.51-2.16,6.21,6.21,0,0,1,4-.42,29.22,29.22,0,0,0,2.8,1,3.61,3.61,0,0,0,3.49-1.48,3.08,3.08,0,0,0,.21-3.56A7.79,7.79,0,0,0,381.54,324.92Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,363.56s-4.2-5.17-12-3.35-9.65,6.45-10.3,9.07c-.79,3.12-1.11,8.53,2.46,9.25,3.86.77,7.81-.64,13.45-5.3S387,363.56,387,363.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.14,340.23a.81.81,0,0,1-.72.16c-1.35-.34-8.07-.21-11,4.11-.57-.28-.63-1-.24-2.15,3.73-3.78,10.09-3.93,11.73-3.52a.77.77,0,0,1,.54,1A.78.78,0,0,1,380.14,340.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.64,349.26a2.47,2.47,0,0,1,0-2.26c3.78-3.33,9.69-3.45,11.26-3.05a.75.75,0,0,1,.54,1,.81.81,0,0,1-.29.43.86.86,0,0,1-.71.16C378.08,345.18,371.7,345.3,368.64,349.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.87,360.6a4.55,4.55,0,0,1,.35-3.07c3.76-3.62,10-3.76,11.58-3.36a.77.77,0,0,1,.54,1,.87.87,0,0,1-.28.42.85.85,0,0,1-.72.16C377.91,355.37,370.5,355.54,367.87,360.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.08,350.46a.82.82,0,0,1-.71.16c-1.34-.34-7.93-.21-10.92,4a2.84,2.84,0,0,1,.12-2.48c3.78-3.33,9.69-3.45,11.26-3.05a.76.76,0,0,1,.54,1A.81.81,0,0,1,380.08,350.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,348s1,20.11-.92,28.42-3,12.35-6.68,19.12c-.8,1.48-2.74,4.31-3.4,5.51a2,2,0,0,0,.85,2.94c2.65,1.62,12,.1,16.41-4.94s7.29-14.39,9.71-18.21c.91-1.44,1.75-2.88,2.51-4.39s.21-2.57,0-4c-.1-.68-.6-2.49-.6-2.49,0-3.42,1.78-9.48,2.11-12.88Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.54,384.25a7.13,7.13,0,0,1,.28,2.42c-.24,1.38-4.35,5.16-5.93,6.51a11.18,11.18,0,0,0-4,7.25c-.83,4.4-3.73,8.15-7.37,11.1a30.79,30.79,0,0,1-17.13,6.31c-7.71.56-9.41-3.63-9.41-3.63s-1.43-4,.24-5.1S379.54,384.25,379.54,384.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,368.91c.22,0,.62.07,1,.88.15.31.72,3.84,1.41,5.79s2.81,5.83,2.54,8.67c-2.89,4.95-8.75,7.5-10.66,12.36s-3.34,10.69-12.5,15.06-17.25,3.18-19.73.89-1.52-5.29,3.81-10.2c5.66-5.22,11.6-18,11.6-18a45.34,45.34,0,0,0,2.06-5.53c.57-1.81.49-3.89.77-5.77a4.27,4.27,0,0,1,.95-2.47,4.4,4.4,0,0,1,2.47-1,18.73,18.73,0,0,1,4.28-.43,6.46,6.46,0,0,1,4,1.44c.78.68,1.34,1.61,2.18,2.22a3.75,3.75,0,0,0,4,.19,3.21,3.21,0,0,0,1.83-3.25S374.56,368.91,374.56,368.91Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,368.91c.22,0,.62.07,1,.88.15.31.72,3.84,1.41,5.79s2.81,5.83,2.54,8.67c-2.89,4.95-8.75,7.5-10.66,12.36s-3.34,10.69-12.5,15.06-17.25,3.18-19.73.89-1.52-5.29,3.81-10.2c5.66-5.22,11.6-18,11.6-18a45.34,45.34,0,0,0,2.06-5.53c.57-1.81.49-3.89.77-5.77a4.27,4.27,0,0,1,.95-2.47,4.4,4.4,0,0,1,2.47-1,18.73,18.73,0,0,1,4.28-.43,6.46,6.46,0,0,1,4,1.44c.78.68,1.34,1.61,2.18,2.22a3.75,3.75,0,0,0,4,.19,3.21,3.21,0,0,0,1.83-3.25S374.56,368.91,374.56,368.91Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,407.78s-1.59-6.79-9.81-8.65-12,1.66-13.84,3.83c-2.16,2.59-4.94,7.53-1.9,9.84,3.29,2.49,7.64,3,15.08,1.15S362,407.78,362,407.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,382.69a.88.88,0,0,1-.75-.17c-1.12-.94-7.51-3.89-12.25-1.17-.41-.52-.14-1.24.75-2.14,5.24-1.85,11.3.92,12.65,2.05a.82.82,0,0,1-.4,1.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.3,385.94a2.62,2.62,0,0,1,1-2.14c5.08-1.41,10.7,1.17,12,2.26a.82.82,0,0,1,.07,1.17.92.92,0,0,1-1.22.09C362.05,386.41,356,383.61,351.3,385.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39,396.27a4.81,4.81,0,0,1,1.74-2.73c5.19-1.7,11.1,1,12.44,2.12a.81.81,0,0,1,.06,1.17.8.8,0,0,1-.46.26.85.85,0,0,1-.75-.17C357.24,395.93,350.19,392.7,345.39,396.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.53,392.29a.85.85,0,0,1-.75-.17c-1.11-.93-7.37-3.82-12.09-1.25a2.94,2.94,0,0,1,1.24-2.27c5.08-1.41,10.7,1.17,12,2.26A.81.81,0,0,1,362,392,.8.8,0,0,1,361.53,392.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.57,227.93c-7.39,6.88-23,14.25-43.06,30.72-4.73,3.87-9,10-4.55,21.92,4.08,10.95,17.55,28.79,25.11,42.46l58.78-81.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.05,321.19c9.32-9.85,36.38-65.76,36.38-65.76l-1.43-.14c-7.92-2.92-11.06-12.12-11.06-12.12a15.3,15.3,0,0,0,3.55,12.14c-4.14,3.55-13.24,11.77-27.58,24.35-2.5,2.19-7.1,7.4-6.28,14.87,1.06,9.77,2,19.37,2,19.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.51,230.37h0l60,4.93c-1.22,13-3.17,23.94-4.58,27.95-2.14,6.07-6.83,12.6-21.22,20.39-15,8.12-30.3,16.36-33.6,18.48-2.49,1.59-1.63,7.48-2,14.49-.34,7.36-.83,11.48-3.74,27.34-1.42,7.71-3.29,16.65-3.29,16.65s-12,3.29-21.58-1.16c0,0-1.08-41.76-1.21-51.2-.11-8.07-1.12-15.51,4.51-21.91,4.82-5.5,34.19-31,34.19-31S381.07,245.13,385.51,230.37Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.15,151.54c-3.65-.32-8.91,1.44-12.49,6.77-4.42,6.58-12.78,29.09-16.58,37.39l-37.65,7.4L342.79,217s23.15-1.83,33.29-2.8c10.84-1,11.2-2.53,12.87-5.08,3.72-5.66,17.45-34.5,17.45-34.5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.57,187.28h0l1.14-1.54v0a1.64,1.64,0,0,1,1.42-.49l17.57.82a5.76,5.76,0,0,1,4.16,2.43L362,217.77a1.5,1.5,0,0,1,.17,1.67h0L361,221v0a1.59,1.59,0,0,1-1.42.5L342,220.69a5.81,5.81,0,0,1-4.16-2.44L319.67,189A1.43,1.43,0,0,1,319.57,187.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.4,188.14a5.78,5.78,0,0,1,2.3,1.93l18.15,29.23a1.55,1.55,0,0,1,.2,1.63l1.11-1.49h0a1.46,1.46,0,0,0-.16-1.66l-18.15-29.24a5.53,5.53,0,0,0-2.13-1.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,219.31l-18.15-29.24a5.73,5.73,0,0,0-4.16-2.43L321,186.82c-1.51-.07-2.08.92-1.29,2.2l18.15,29.23a5.81,5.81,0,0,0,4.16,2.44l17.58.81C361.06,221.57,361.64,220.59,360.84,219.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.17,196.73l-3.39-5.48a1.11,1.11,0,0,0-.78-.45l-3-.13c-.28,0-.39.17-.24.41l3.4,5.47a1.12,1.12,0,0,0,.78.46l3,.13C344.21,197.15,344.32,197,344.17,196.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,192.71a2.75,2.75,0,0,0-2-1.12c-.73,0-1,.42-.67,1a2.74,2.74,0,0,0,2,1.11C341,193.73,341.32,193.29,341,192.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.63,195.48a2.71,2.71,0,0,0-2-1.12c-.72,0-1,.42-.66,1a2.72,2.72,0,0,0,2,1.11C342.7,196.5,343,196.06,342.63,195.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,205.25c-2.29-1.78-2.23-2.12-1.7-3.53a7.43,7.43,0,0,1,4.9-4.7c2-.54,4-1.17,5.17-1s1,2.63-1.45,4c-3.8,2.13-3.45,3.23-3.45,3.23a55.13,55.13,0,0,1,5-2.5c1.48-.53,4.45-.64,6.25-.88s2.8,1.87.11,3.5l3.3-.43c2.31-.31,3.42.64,2.09,2.52a3.37,3.37,0,0,1-1.77,1.35s2.35-.71,2.63.06c.81,2.19-.46,3.22-4.8,6-4.13,2.66-4.33,5.38-2.93,6.79,0,0-2.14-.52-4.1-1.15-1.43-.47-2.71-1.09-2.73-3.1,0,0-2.58.82-3.21-.73a8.51,8.51,0,0,1-.4-3.61,2.94,2.94,0,0,1-2.22-2.23,4.77,4.77,0,0,1,.1-3.09Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.79,203.41a16.42,16.42,0,0,0-3,.55,9.86,9.86,0,0,0-2.5,1.71,35,35,0,0,0-4.19,4.16,34.87,34.87,0,0,0,4.74-3.49,15.2,15.2,0,0,1,2.23-1.76C338.93,204.18,339.92,203.87,340.79,203.41Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,206.85a6.5,6.5,0,0,0-3.12.83,16.93,16.93,0,0,0-2.67,1.81,30.52,30.52,0,0,0-4.52,4.5,62.2,62.2,0,0,0,5.07-3.82A16.48,16.48,0,0,1,344.41,206.85Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.25,149.84c-4.61.18-11.06,1.41-14.56,7.21-3,5-13.89,29.79-13.89,29.79s2.44,4.07,8.54,7.06c8.15,4,12.59,4,12.59,4l10.73-23.78Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.69,149.88c7.74.64,22.55,3.5,32.94,12,2.6,2.35,5.22,9.59,2.87,23.54s-3.91,25.83-4.86,32.77c-1.85,13.58-4.29,28.58-4.29,28.58-20.9,7.66-56.18-4.81-63.34-18.48,3.52-5.73,2.75-10.49,7.16-45.58,2.51-20,6.44-28.61,15.08-32.82A103.57,103.57,0,0,1,417.69,149.88Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.69,149.88a103.42,103.42,0,0,0-14.43,0c-6,2.93-9.75,8-12.31,17.53,16.76,9.76,43.27,18.33,62.43,18.68l.12-.68c2.35-14-.27-21.19-2.87-23.54C440.24,153.38,425.43,150.52,417.69,149.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.17,115.89c-.82-1.27-2.27-4-1-5.35-2.36-1.23-3.6-6.61.22-5.11-4.66-1.84-5.71-8.65-3.81-9.62,1.09-.55,2.39.66,4.89.85,4.59.36,4.36-.43,12.48-3.11C420.6,91.36,440.2,92,440,106c6.31,1.49,5.83,11.62,3.71,15.84-3.92,7.77-7.49,12.84-9.58,18.48C430.28,137.46,407.05,122.56,401.17,115.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.73,134.67c-4,2.58-6.28-.31-6.28-.31l-1.2,19.42c-8.55,9.72-29.51,6.7-19.72-3l.18-5.67a40.23,40.23,0,0,1-5.08-.82,12,12,0,0,1-3.74-1.45,7.66,7.66,0,0,1-3.7-5.53,50.4,50.4,0,0,1-1-14.05c.34-5.64,1.94-14.55,4-18.21,3.56-2.76,9.88,3.69,21.56,2.6a11.19,11.19,0,0,0,2.05,6.36,8.81,8.81,0,0,0,3.06,2.74,17.6,17.6,0,0,0-1.07,6.92,2.35,2.35,0,0,0,3.23,2.06c1-.29,1.87-2.42,3-3.81,1.49-1.85,5.85-2.49,7.67,1.86A9.32,9.32,0,0,1,440.73,134.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.72,145.07c4.29-.15,11.92-.27,14.29-2.74s4.46-8.36,4.46-8.36-1.28,6.7-3.14,9.52-5.62,3.78-8.36,4.42a45.84,45.84,0,0,1-7.39.75Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.57,115.21l3.79,2.78a2.46,2.46,0,0,0-.53-3.37A2.29,2.29,0,0,0,420.57,115.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.14,113.6l-4.43,1.6a2.47,2.47,0,0,1,1.47-3.09A2.3,2.3,0,0,1,408.14,113.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.92,132.73l-6.09,1.54a3.3,3.3,0,0,0,3.93,2.33A3.07,3.07,0,0,0,417.92,132.73Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.6,133.93a3.06,3.06,0,0,0-3.4,2.64,3.16,3.16,0,0,0,1.56,0A3,3,0,0,0,418,134,2,2,0,0,0,417.6,133.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.47,121.19a1.92,1.92,0,1,1-1.72-2.11A1.93,1.93,0,0,1,422.47,121.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.13,119.45a1.92,1.92,0,1,1-1.72-2.11A1.92,1.92,0,0,1,408.13,119.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.61 126.23 411.92 130.25 415.81 116.72 406.61 126.23",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.38,44.14c.84.62,1.68,1.25,2.5,1.9a.58.58,0,0,1,.14.75.47.47,0,0,1-.7.09c-.8-.64-1.63-1.26-2.46-1.87a.58.58,0,0,1-.17-.75.46.46,0,0,1,.69-.12Zm6.51,5.3c.78.71,1.56,1.44,2.3,2.18a.56.56,0,0,1,.06.75.47.47,0,0,1-.7,0c-.73-.73-1.5-1.45-2.27-2.15a.56.56,0,0,1-.09-.75.39.39,0,0,1,.17-.14A.49.49,0,0,1,362.89,49.44Zm5.94,6c.71.81,1.4,1.64,2.05,2.46a.54.54,0,0,1,0,.75.48.48,0,0,1-.7-.1c-.65-.8-1.32-1.62-2-2.41a.54.54,0,0,1,0-.75.34.34,0,0,1,.12-.09A.49.49,0,0,1,368.83,55.47Zm5.23,6.76c.59.87,1.18,1.78,1.74,2.7a.53.53,0,0,1-.13.73.5.5,0,0,1-.69-.2c-.55-.9-1.13-1.79-1.72-2.65a.55.55,0,0,1,.1-.74l.07,0A.53.53,0,0,1,374.06,62.23Zm4.36,7.38c.38.75.75,1.51,1.11,2.27l.28.63a.51.51,0,0,1-.21.69h0a.52.52,0,0,1-.67-.3l-.28-.61c-.35-.76-.72-1.5-1.09-2.24a.52.52,0,0,1,.19-.71h0A.52.52,0,0,1,378.42,69.61Zm2.77,7.52a.53.53,0,0,1,.65.35c.36,1,.71,2,1,3a.49.49,0,0,1-.3.65.55.55,0,0,1-.64-.38c-.32-1-.66-2-1-3a.51.51,0,0,1,.24-.65Zm2.5,8.12a.54.54,0,0,1,.61.44c.24,1,.46,2.09.65,3.13a.5.5,0,0,1-.4.6.57.57,0,0,1-.59-.48c-.18-1-.39-2.06-.63-3.07a.51.51,0,0,1,.25-.59Zm1.41,8.32a.57.57,0,0,1,.55.53c.09,1.05.16,2.11.19,3.17a.48.48,0,0,1-.48.51.58.58,0,0,1-.52-.56c0-1-.09-2.08-.19-3.11a.52.52,0,0,1,.27-.5A.58.58,0,0,1,385.1,93.57Zm.2,8.36a.58.58,0,0,1,.47.6c-.07,1-.16,2.1-.28,3.13a.46.46,0,0,1-.56.41.58.58,0,0,1-.43-.63c.12-1,.21-2,.27-3.06A.49.49,0,0,1,385,102,.46.46,0,0,1,385.3,101.93Zm-1,8.18a.59.59,0,0,1,.38.67c-.22,1-.46,2-.73,3a.45.45,0,0,1-.61.32.6.6,0,0,1-.35-.69c.26-1,.5-2,.71-3a.52.52,0,0,1,.26-.33A.44.44,0,0,1,384.27,110.11Zm-2.2,7.82a.6.6,0,0,1,.29.72c-.36.95-.75,1.9-1.15,2.81a.45.45,0,0,1-.66.21.56.56,0,0,1-.25-.72c.39-.9.77-1.83,1.12-2.77a.51.51,0,0,1,.24-.26A.46.46,0,0,1,382.07,117.93Zm-3.31,7.29a.57.57,0,0,1,.18.74c-.5.88-1,1.74-1.58,2.55a.47.47,0,0,1-.69.09.58.58,0,0,1-.13-.76c.53-.78,1-1.62,1.54-2.49a.52.52,0,0,1,.2-.19A.49.49,0,0,1,378.76,125.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.65,131.51l-.12.09a8.1,8.1,0,0,1-1.07.9.54.54,0,0,0-.11.73.49.49,0,0,0,.69.19,8.12,8.12,0,0,0,1.19-1,.54.54,0,0,0,0-.75A.51.51,0,0,0,373.65,131.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.61 159.73 368.48 152.44 372.14 137.42 331.61 159.73",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.61 159.73 368.48 152.44 372.14 137.42 331.61 159.73",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,175.76c-1.7-.57-2.44-3-3.22-6.27a17.39,17.39,0,0,0-2.19-5.35s3.54-.29,4.78,2.48S374.71,175.76,374.71,175.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.93,177.4c-4.63-4.59-8.63-7.55-10.07-11.47s-3.6-12.07-4.3-13.38-3.12-2.07-5.51-3.26-5.05-2.82-6.73-2.47-7.47,4.15-9.13,5.45-.74,2.8,0,3.1c0,0-2.26,2.13-3,2.83s.22,2.43,2.09,2a5.07,5.07,0,0,0,2.5-1.07,16.55,16.55,0,0,0,.28,3.63,3,3,0,0,0,.84,1.32,2.39,2.39,0,0,0,.5,1.93,9.7,9.7,0,0,0,1.91,2.62c.61.48,1.58-.16,1.94-1.38a3.27,3.27,0,0,0-.51-2.09l.5-.43,1.84.29a10.49,10.49,0,0,1,2.9,2.54c1,1.45,1.12,3.15,1.83,5.74a11.74,11.74,0,0,0,4.37,6.79,82.5,82.5,0,0,1,6.89,7.12Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,160.77c.62.11,2.09-.39.54-1a23.42,23.42,0,0,0-3.09-1,26.43,26.43,0,0,1-3.06.7,27.84,27.84,0,0,1,3.47.82C370.62,160.42,372,160.77,372,160.77Z",
    style: {
      fill: "#f28f8f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.82,152.4a1.48,1.48,0,0,1-.59.2,2.64,2.64,0,0,1-.63,0c-.42-.06-.82-.17-1.22-.26-.8-.21-1.59-.42-2.38-.65s-1.57-.46-2.35-.67l-1.17-.32a5.88,5.88,0,0,0-1.11-.17h-.24l-.21.06-.52.24c-.35.17-.7.38-1,.58-.71.4-1.41.82-2.14,1.21a28.88,28.88,0,0,0-4,2.76,20.47,20.47,0,0,1,1.7-1.79,13.31,13.31,0,0,1,2-1.53l2.07-1.34c.35-.22.71-.42,1.08-.62.19-.1.38-.2.6-.29a1.81,1.81,0,0,1,.37-.1,1.76,1.76,0,0,1,.38,0,5.78,5.78,0,0,1,1.31.22c.41.1.81.22,1.2.35.78.26,1.56.52,2.32.81s1.54.58,2.3.88c.38.15.76.3,1.15.42A1.74,1.74,0,0,0,377.82,152.4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,155.74a2,2,0,0,1-1,0c-.34-.08-.67-.2-1-.31-.65-.23-1.29-.48-1.92-.73s-1.28-.5-1.91-.7a6.9,6.9,0,0,0-.94-.25,1.6,1.6,0,0,0-.79,0,2.09,2.09,0,0,0-.37.21c-.14.08-.28.18-.42.27l-.82.6c-.55.39-1.07.82-1.6,1.24-.27.22-.53.44-.77.66s-.48.48-.71.72a4.11,4.11,0,0,0-.61.78,2.7,2.7,0,0,0-.3,1,2.5,2.5,0,0,1,.08-1.05,4.32,4.32,0,0,1,.51-.95c.21-.29.4-.55.63-.84s.48-.52.73-.77c.49-.49,1-.94,1.55-1.38.27-.22.55-.43.84-.64l.44-.3a2.75,2.75,0,0,1,.52-.29,2.32,2.32,0,0,1,1.25,0,7,7,0,0,1,1,.31,20.51,20.51,0,0,1,1.91.85c.62.3,1.22.63,1.83.95.3.17.6.33.91.47a3.85,3.85,0,0,0,.47.19A1.19,1.19,0,0,0,375,155.74Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.05,160.77a3,3,0,0,1-1.74.25,16.63,16.63,0,0,1-1.74-.3c-1.13-.26-2.28-.58-3.35-.84a3.49,3.49,0,0,0-.75-.08,1.06,1.06,0,0,0-.31,0l-.15.07a.35.35,0,0,0-.12.07,3.18,3.18,0,0,0-.52.56c-.18.21-.34.44-.51.67-.65.94-1.29,1.9-1.93,2.88a14.14,14.14,0,0,1,1.35-3.24c.15-.26.31-.51.48-.77a3.71,3.71,0,0,1,.62-.73,1.59,1.59,0,0,1,.25-.17l.25-.11a2,2,0,0,1,.54-.11,3,3,0,0,1,1,.1c.6.14,1.15.32,1.7.5l1.64.57c.55.18,1.09.37,1.64.52A3.3,3.3,0,0,0,374.05,160.77Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.66,159.73a2.14,2.14,0,0,1-.41-1,4.48,4.48,0,0,1-.07-1,4.28,4.28,0,0,0,.45.79,1.62,1.62,0,0,0,.58.52Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.61 159.73 372.14 137.42 388.9 144.06 331.61 159.73",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.61 159.73 372.14 137.42 388.9 144.06 331.61 159.73",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.61 159.73 367.07 133.94 360.18 124.82 331.61 159.73",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.61 159.73 367.07 133.94 360.18 124.82 331.61 159.73",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.07 133.94 366.64 140.44 331.61 159.73 367.07 133.94",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.07 133.94 366.64 140.44 331.61 159.73 367.07 133.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66,172.81c10.25,8.93,23.39,20.33,23.39,20.33l17.33-14.37s11.46-15.7,19.25-16.94c5.85,4.41,6.61,10.73,5.62,15.91-2,10.55-7.79,13.48-18.71,22.86-10.75,9.24-16.83,14-20.45,15.84s-9.18-.6-17.13-9.95-18.42-23.17-18.42-23.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.58,161c4,2.46,7.17,6.38,8.38,12.72s-2.28,12.94-11.62,20.62-15.44,12.83-15.44,12.83-4.84-12.43-13.81-16.64c0,0,11.94-12.27,15-15.48C435.45,171.56,444.68,161,449.58,161Z",
    style: {
      fill: "#455a64"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444,433.58l-7.24-4.18s-4.31-17.9-2.59-34c2.41-22.64,17.32-31.16,23-29.21s7.31,8.54-2.06,22C449.59,396.17,442.8,412.74,444,433.58Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444,433.58l-7.24-4.18s-4.31-17.9-2.59-34c2.41-22.64,17.32-31.16,23-29.21s7.31,8.54-2.06,22C449.59,396.17,442.8,412.74,444,433.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M441,424.79h.07a.5.5,0,0,0,.4-.59c-4-20.88,3.33-44.35,12.36-54.11a.5.5,0,0,0-.74-.68c-9.2,9.94-16.63,33.79-12.61,55A.51.51,0,0,0,441,424.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.25,444.1c1.08.55,4-1.91,4.76-2.51a10.09,10.09,0,0,0,3.14-4,9.37,9.37,0,0,0,.55-5.68,22.34,22.34,0,0,0-.86-3l-1-2.87a7.38,7.38,0,0,1-.57-2.92c.15-2,1.85-3.49,3.4-4.77,1.71-1.42,3.47-3.27,3.34-5.67a8.42,8.42,0,0,0-2.37-4.91c-1.22-1.4-2.64-2.61-3.76-4.09A5.89,5.89,0,0,1,467.5,400a6.05,6.05,0,0,1,.69-2.37,31.58,31.58,0,0,0,2.31-4.8c.5-1.71.32-3.79-1.05-4.92a5.51,5.51,0,0,0-4.18-.82,9.56,9.56,0,0,0-3.77,1.54c-3.7,2.31-5.65,6.93-9.61,8.77a41.94,41.94,0,0,1-4.83,1.44,6,6,0,0,0-3.89,3c-1.34,3,1.6,6.55.72,9.75-.79,2.83-3.44,4-4.83,6.61a6,6,0,0,0-.53,3.68,17.64,17.64,0,0,0,1.85,6.08,54.42,54.42,0,0,0,3.66,5.62Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.25,444.1c1.08.55,4-1.91,4.76-2.51a10.09,10.09,0,0,0,3.14-4,9.37,9.37,0,0,0,.55-5.68,22.34,22.34,0,0,0-.86-3l-1-2.87a7.38,7.38,0,0,1-.57-2.92c.15-2,1.85-3.49,3.4-4.77,1.71-1.42,3.47-3.27,3.34-5.67a8.42,8.42,0,0,0-2.37-4.91c-1.22-1.4-2.64-2.61-3.76-4.09A5.89,5.89,0,0,1,467.5,400a6.05,6.05,0,0,1,.69-2.37,31.58,31.58,0,0,0,2.31-4.8c.5-1.71.32-3.79-1.05-4.92a5.51,5.51,0,0,0-4.18-.82,9.56,9.56,0,0,0-3.77,1.54c-3.7,2.31-5.65,6.93-9.61,8.77a41.94,41.94,0,0,1-4.83,1.44,6,6,0,0,0-3.89,3c-1.34,3,1.6,6.55.72,9.75-.79,2.83-3.44,4-4.83,6.61a6,6,0,0,0-.53,3.68,17.64,17.64,0,0,0,1.85,6.08,54.42,54.42,0,0,0,3.66,5.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451.78,438.64h0a.47.47,0,0,0,.43-.52c-1.73-18.78,6.09-40,12.24-46.37a.49.49,0,0,0,0-.68.47.47,0,0,0-.67,0c-6.27,6.49-14.26,28.07-12.5,47.12A.48.48,0,0,0,451.78,438.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.64,415.48a.35.35,0,0,0,.14,0,62.78,62.78,0,0,1,13.55-2.89.49.49,0,0,0,.43-.52.46.46,0,0,0-.52-.43,65.22,65.22,0,0,0-13.79,2.95.48.48,0,0,0,.19.92Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharelinkAmico);
export default __webpack_public_path__ + "static/media/Share link-amico.2390f364f1f204cdf130ec1d5e254768.svg";
export { ForwardRef as ReactComponent };